// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800;900&family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Women-Empowerment Google Fonts ===== */

@tailwind base;
@tailwind components;
@tailwind utilities;

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

html, body{
  margin: 0px;
  height: 100%;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(250 241 242 / var(--tw-bg-opacity, 1));
  padding: 0px;
  font-family: Inter, sans-serif;
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.-left-\\[7px\\]{
  left: -7px;
}
.-top-\\[11px\\]{
  top: -11px;
}
.-top-\\[4px\\]{
  top: -4px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-\\[6px\\]{
  bottom: 6px;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-8{
  left: 2rem;
}
.left-\\[100px\\]{
  left: 100px;
}
.left-\\[16px\\]{
  left: 16px;
}
.left-\\[20px\\]{
  left: 20px;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-4{
  right: 1rem;
}
.right-8{
  right: 2rem;
}
.right-\\[20px\\]{
  right: 20px;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-10{
  top: 2.5rem;
}
.top-4{
  top: 1rem;
}
.top-\\[6px\\]{
  top: 6px;
}
.top-\\[70px\\]{
  top: 70px;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[10000\\]{
  z-index: 10000;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[2\\]{
  z-index: 2;
}
.z-\\[5\\]{
  z-index: 5;
}
.z-\\[99999\\]{
  z-index: 99999;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.m-0{
  margin: 0px;
}
.m-2{
  margin: 0.5rem;
}
.m-3{
  margin: 0.75rem;
}
.-mx-\\[12px\\]{
  margin-left: -12px;
  margin-right: -12px;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-ml-\\[12px\\]{
  margin-left: -12px;
}
.-ml-\\[50\\%\\]{
  margin-left: -50%;
}
.-mr-\\[50\\%\\]{
  margin-right: -50%;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[12px\\]{
  margin-bottom: 12px;
}
.mb-\\[14px\\]{
  margin-bottom: 14px;
}
.mb-\\[16px\\]{
  margin-bottom: 16px;
}
.mb-\\[24px\\]{
  margin-bottom: 24px;
}
.mb-\\[30px\\]{
  margin-bottom: 30px;
}
.mb-\\[6px\\]{
  margin-bottom: 6px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.mr-auto{
  margin-right: auto;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-\\[12px\\]{
  margin-top: 12px;
}
.mt-\\[16px\\]{
  margin-top: 16px;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.mt-\\[8px\\]{
  margin-top: 8px;
}
.mt-auto{
  margin-top: auto;
}
.box-border{
  box-sizing: border-box;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-1{
  height: 0.25rem;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[10\\%\\]{
  height: 10%;
}
.h-\\[100dvh\\]{
  height: 100dvh;
}
.h-\\[110px\\]{
  height: 110px;
}
.h-\\[115px\\]{
  height: 115px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[20vh\\]{
  height: 20vh;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[24px\\]{
  height: 24px;
}
.h-\\[25vh\\]{
  height: 25vh;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[36px\\]{
  height: 36px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[42px\\]{
  height: 42px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[56px\\]{
  height: 56px;
}
.h-\\[58px\\]{
  height: 58px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[64px\\]{
  height: 64px;
}
.h-\\[70\\%\\]{
  height: 70%;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[80\\%\\]{
  height: 80%;
}
.h-\\[84px\\]{
  height: 84px;
}
.h-\\[90\\%\\]{
  height: 90%;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-\\[320px\\]{
  max-height: 320px;
}
.max-h-\\[340px\\]{
  max-height: 340px;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[50vh\\]{
  max-height: 50vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[50vh\\]{
  min-height: 50vh;
}
.min-h-\\[56px\\]{
  min-height: 56px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[calc\\(100vh-140px\\)\\]{
  min-height: calc(100vh - 140px);
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1{
  width: 0.25rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-16{
  width: 4rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 5rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-4{
  width: 1rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[115px\\]{
  width: 115px;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[15\\%\\]{
  width: 15%;
}
.w-\\[16px\\]{
  width: 16px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[24px\\]{
  width: 24px;
}
.w-\\[25\\%\\]{
  width: 25%;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[31\\%\\]{
  width: 31%;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[36px\\]{
  width: 36px;
}
.w-\\[38px\\]{
  width: 38px;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[42px\\]{
  width: 42px;
}
.w-\\[44px\\]{
  width: 44px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[47\\%\\]{
  width: 47%;
}
.w-\\[50vw\\]{
  width: 50vw;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[56px\\]{
  width: 56px;
}
.w-\\[58px\\]{
  width: 58px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[75\\%\\]{
  width: 75%;
}
.w-\\[80vw\\]{
  width: 80vw;
}
.w-\\[84px\\]{
  width: 84px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[90px\\]{
  width: 90px;
}
.w-\\[90vw\\]{
  width: 90vw;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-\\[95vw\\]{
  width: 95vw;
}
.w-\\[calc\\(100\\%\\+24px\\)\\]{
  width: calc(100% + 24px);
}
.w-\\[calc\\(33\\.333\\%-8px\\)\\]{
  width: calc(33.333% - 8px);
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[700px\\]{
  min-width: 700px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[450px\\]{
  max-width: 450px;
}
.max-w-\\[460px\\]{
  max-width: 460px;
}
.max-w-\\[540px\\]{
  max-width: 540px;
}
.max-w-\\[560px\\]{
  max-width: 560px;
}
.max-w-\\[620px\\]{
  max-width: 620px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[95\\%\\]{
  max-width: 95%;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.border-collapse{
  border-collapse: collapse;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/3{
  --tw-translate-y: -33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-8{
  --tw-translate-y: -2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full{
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/3{
  --tw-translate-x: 33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.resize-none{
  resize: none;
}
.list-outside{
  list-style-position: outside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-evenly{
  justify-content: space-evenly;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-\\[16px\\]{
  gap: 16px;
}
.gap-\\[4px\\]{
  gap: 4px;
}
.gap-\\[8px\\]{
  gap: 8px;
}
.gap-x-1{
  column-gap: 0.25rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-indigo-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[12px\\]{
  border-radius: 12px;
}
.rounded-\\[14px\\]{
  border-radius: 14px;
}
.rounded-\\[16px\\]{
  border-radius: 16px;
}
.rounded-\\[18px\\]{
  border-radius: 18px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-l-lg{
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[20px\\]{
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-bl-\\[24px\\]{
  border-bottom-left-radius: 24px;
}
.rounded-bl-lg{
  border-bottom-left-radius: 0.5rem;
}
.rounded-br-\\[24px\\]{
  border-bottom-right-radius: 24px;
}
.rounded-br-lg{
  border-bottom-right-radius: 0.5rem;
}
.rounded-tl-\\[8px\\]{
  border-top-left-radius: 8px;
}
.rounded-tr-\\[24px\\]{
  border-top-right-radius: 24px;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[1\\.2px\\]{
  border-width: 1.2px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-\\[1\\.6px\\]{
  border-width: 1.6px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-\\[5px\\]{
  border-width: 5px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[0\\.8px\\]{
  border-bottom-width: 0.8px;
}
.border-b-\\[4px\\]{
  border-bottom-width: 4px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-\\[0\\.8px\\]{
  border-right-width: 0.8px;
}
.border-r-\\[1\\.5px\\]{
  border-right-width: 1.5px;
}
.border-r-\\[2px\\]{
  border-right-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-\\[0\\.8px\\]{
  border-top-width: 0.8px;
}
.border-t-\\[4px\\]{
  border-top-width: 4px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#4a0e1e\\]{
  --tw-border-opacity: 1;
  border-color: rgb(74 14 30 / var(--tw-border-opacity, 1));
}
.border-\\[\\#8B1A4A\\]{
  --tw-border-opacity: 1;
  border-color: rgb(139 26 74 / var(--tw-border-opacity, 1));
}
.border-\\[\\#969696\\]{
  --tw-border-opacity: 1;
  border-color: rgb(150 150 150 / var(--tw-border-opacity, 1));
}
.border-\\[\\#9c2942\\]{
  --tw-border-opacity: 1;
  border-color: rgb(156 41 66 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E0E0E0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E2E8F0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E7F3FF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(231 243 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFD6A8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 214 168 / var(--tw-border-opacity, 1));
}
.border-\\[\\#b5677e\\]{
  --tw-border-opacity: 1;
  border-color: rgb(181 103 126 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c1671f\\]{
  --tw-border-opacity: 1;
  border-color: rgb(193 103 31 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e07a2c\\]\\/35{
  border-color: rgb(224 122 44 / 0.35);
}
.border-\\[\\#e8d3d8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(232 211 216 / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/80{
  border-color: rgb(191 219 254 / 0.8);
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-brand-teal{
  --tw-border-opacity: 1;
  border-color: rgb(156 41 66 / var(--tw-border-opacity, 1));
}
.border-cream{
  --tw-border-opacity: 1;
  border-color: rgb(253 245 246 / var(--tw-border-opacity, 1));
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-50{
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity, 1));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-green-100{
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-indigo-800{
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity, 1));
}
.border-navy-dark{
  --tw-border-opacity: 1;
  border-color: rgb(74 14 30 / var(--tw-border-opacity, 1));
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-400{
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-l-green-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-t-purple-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#0e2f4d\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(14 47 77 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#143A78\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 58 120 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#251e8a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 30 138 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#45B07B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(69 176 123 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4a0e1e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(74 14 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7a1830\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(122 24 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8B1A4A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(139 26 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#9c2942\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(156 41 66 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5E7EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F2FA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 242 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECFDF5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F5F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 245 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8FAFC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF8020\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 128 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF7EC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFFFF9E\\]{
  background-color: #FFFFFF9E;
}
.bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#c9962f\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(201 150 47 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d1d8dc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(209 216 220 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ecf0fb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 240 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f7f9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 247 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7eef0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 238 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#faf1f2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 241 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fde3e1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 227 225 / var(--tw-bg-opacity, 1));
}
.bg-\\[white\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/70{
  background-color: rgb(239 246 255 / 0.7);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-700{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-brand-teal{
  --tw-bg-opacity: 1;
  background-color: rgb(156 41 66 / var(--tw-bg-opacity, 1));
}
.bg-brand-teal\\/10{
  background-color: rgb(156 41 66 / 0.1);
}
.bg-cream\\/30{
  background-color: rgb(253 245 246 / 0.3);
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/70{
  background-color: rgb(240 253 244 / 0.7);
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-700{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/80{
  background-color: rgb(238 242 255 / 0.8);
}
.bg-indigo-50\\/90{
  background-color: rgb(238 242 255 / 0.9);
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-navy-dark{
  --tw-bg-opacity: 1;
  background-color: rgb(74 14 30 / var(--tw-bg-opacity, 1));
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-page-bg{
  --tw-bg-opacity: 1;
  background-color: rgb(250 241 242 / var(--tw-bg-opacity, 1));
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/40{
  background-color: rgb(250 245 255 / 0.4);
}
.bg-purple-50\\/70{
  background-color: rgb(250 245 255 / 0.7);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-saffron{
  --tw-bg-opacity: 1;
  background-color: rgb(201 150 47 / var(--tw-bg-opacity, 1));
}
.bg-saffron\\/10{
  background-color: rgb(201 150 47 / 0.1);
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/50{
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-600{
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60{
  --tw-bg-opacity: 0.6;
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#4C9F50\\]{
  --tw-gradient-from: #4C9F50 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(76 159 80 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#4a0e1e\\]{
  --tw-gradient-from: #4a0e1e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(74 14 30 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#8CB8F9\\]{
  --tw-gradient-from: #8CB8F9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(140 184 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#9c2942\\]{
  --tw-gradient-from: #9c2942 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 41 66 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#EECA46\\]{
  --tw-gradient-from: #EECA46 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 202 70 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FE6700\\]{
  --tw-gradient-from: #FE6700 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 103 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FF8904\\]{
  --tw-gradient-from: #FF8904 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 137 4 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#eaefff\\]{
  --tw-gradient-from: #eaefff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 239 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ffffff\\]{
  --tw-gradient-from: #ffffff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/70{
  --tw-gradient-from: rgb(239 246 255 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-900{
  --tw-gradient-from: #312e81 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-700{
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#f7eef0\\]{
  --tw-gradient-to: rgb(247 238 240 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f7eef0 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-50\\/30{
  --tw-gradient-to: rgb(249 250 251 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(249 250 251 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-700{
  --tw-gradient-to: rgb(67 56 202 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #4338ca var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#126C17\\]{
  --tw-gradient-to: #126C17 var(--tw-gradient-to-position);
}
.to-\\[\\#4a0e1e\\]{
  --tw-gradient-to: #4a0e1e var(--tw-gradient-to-position);
}
.to-\\[\\#6494DE\\]{
  --tw-gradient-to: #6494DE var(--tw-gradient-to-position);
}
.to-\\[\\#9c2942\\]{
  --tw-gradient-to: #9c2942 var(--tw-gradient-to-position);
}
.to-\\[\\#E8B522\\]{
  --tw-gradient-to: #E8B522 var(--tw-gradient-to-position);
}
.to-\\[\\#F1BC81\\]{
  --tw-gradient-to: #F1BC81 var(--tw-gradient-to-position);
}
.to-\\[\\#F54900\\]{
  --tw-gradient-to: #F54900 var(--tw-gradient-to-position);
}
.to-\\[\\#fbeef1\\]{
  --tw-gradient-to: #fbeef1 var(--tw-gradient-to-position);
}
.to-\\[\\#ffffff\\]{
  --tw-gradient-to: #ffffff var(--tw-gradient-to-position);
}
.to-blue-700{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-indigo-50\\/70{
  --tw-gradient-to: rgb(238 242 255 / 0.7) var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-purple-900{
  --tw-gradient-to: #581c87 var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-clip-text{
  background-clip: text;
}
.bg-center{
  background-position: center;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[14px\\]{
  padding: 14px;
}
.p-\\[15px\\]{
  padding: 15px;
}
.p-\\[18px_22px\\]{
  padding: 18px 22px;
}
.p-\\[25px\\]{
  padding: 25px;
}
.p-\\[6px\\]{
  padding: 6px;
}
.p-\\[8px_8px_8px_18px\\]{
  padding: 8px 8px 8px 18px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[10px\\]{
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[14px\\]{
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[16px\\]{
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[22px\\]{
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[40px\\]{
  padding-left: 40px;
  padding-right: 40px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[10px\\]{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[13px\\]{
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[30px\\]{
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[32px\\]{
  padding-top: 32px;
  padding-bottom: 32px;
}
.py-\\[3px\\]{
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[8px\\]{
  padding-top: 8px;
  padding-bottom: 8px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-36{
  padding-bottom: 9rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-\\[10px\\]{
  padding-top: 10px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-start{
  text-align: start;
}
.align-top{
  vertical-align: top;
}
.font-\\[\\'Inter\\'\\]{
  font-family: 'Inter';
}
.font-\\[Roboto\\]{
  font-family: Roboto;
}
.font-heading{
  font-family: Merriweather, serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
  font-family: Inter, sans-serif;
}
.font-serif{
  font-family: Merriweather, serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14\\.5px\\]{
  font-size: 14.5px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[34px\\]{
  font-size: 34px;
}
.text-\\[36px\\]{
  font-size: 36px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.font-\\[600\\]{
  font-weight: 600;
}
.font-\\[700\\]{
  font-weight: 700;
}
.font-\\[800\\]{
  font-weight: 800;
}
.font-\\[900\\]{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-\\[1\\.08\\]{
  line-height: 1.08;
}
.leading-\\[1\\.7\\]{
  line-height: 1.7;
}
.leading-\\[16px\\]{
  line-height: 16px;
}
.leading-\\[28px\\]{
  line-height: 28px;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.4px\\]{
  letter-spacing: 0.4px;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#0000006E\\]{
  color: #0000006E;
}
.text-\\[\\#0e2f4d\\]{
  --tw-text-opacity: 1;
  color: rgb(14 47 77 / var(--tw-text-opacity, 1));
}
.text-\\[\\#10293d\\]{
  --tw-text-opacity: 1;
  color: rgb(16 41 61 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a1a71\\]{
  --tw-text-opacity: 1;
  color: rgb(26 26 113 / var(--tw-text-opacity, 1));
}
.text-\\[\\#247087\\]{
  --tw-text-opacity: 1;
  color: rgb(36 112 135 / var(--tw-text-opacity, 1));
}
.text-\\[\\#251e8a\\]{
  --tw-text-opacity: 1;
  color: rgb(37 30 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#300a14\\]{
  --tw-text-opacity: 1;
  color: rgb(48 10 20 / var(--tw-text-opacity, 1));
}
.text-\\[\\#333333\\]{
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity, 1));
}
.text-\\[\\#414141\\]{
  --tw-text-opacity: 1;
  color: rgb(65 65 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4D4646\\]\\/80{
  color: rgb(77 70 70 / 0.8);
}
.text-\\[\\#4a0e1e\\]{
  --tw-text-opacity: 1;
  color: rgb(74 14 30 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4b5563\\]{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4c6478\\]{
  --tw-text-opacity: 1;
  color: rgb(76 100 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5D5D5D\\]{
  --tw-text-opacity: 1;
  color: rgb(93 93 93 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7c93a3\\]{
  --tw-text-opacity: 1;
  color: rgb(124 147 163 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8B1A4A\\]{
  --tw-text-opacity: 1;
  color: rgb(139 26 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#943ab7\\]{
  --tw-text-opacity: 1;
  color: rgb(148 58 183 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9c2942\\]{
  --tw-text-opacity: 1;
  color: rgb(156 41 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E17100\\]{
  --tw-text-opacity: 1;
  color: rgb(225 113 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F16D01\\]{
  --tw-text-opacity: 1;
  color: rgb(241 109 1 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c1671f\\]{
  --tw-text-opacity: 1;
  color: rgb(193 103 31 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e0433a\\]{
  --tw-text-opacity: 1;
  color: rgb(224 67 58 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e07a2c\\]{
  --tw-text-opacity: 1;
  color: rgb(224 122 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f2f2f6\\]{
  --tw-text-opacity: 1;
  color: rgb(242 242 246 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-brand-teal{
  --tw-text-opacity: 1;
  color: rgb(156 41 66 / var(--tw-text-opacity, 1));
}
.text-cream{
  --tw-text-opacity: 1;
  color: rgb(253 245 246 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-950{
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-indigo-950{
  --tw-text-opacity: 1;
  color: rgb(30 27 75 / var(--tw-text-opacity, 1));
}
.text-navy-dark{
  --tw-text-opacity: 1;
  color: rgb(74 14 30 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-purple-200{
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900{
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-saffron{
  --tw-text-opacity: 1;
  color: rgb(201 150 47 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-teal-800{
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/\\[\\.5\\]{
  color: rgb(255 255 255 / .5);
}
.text-yellow-300{
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.decoration-dotted{
  text-decoration-style: dotted;
}
.placeholder-\\[\\#90A1B9\\]::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(144 161 185 / var(--tw-placeholder-opacity, 1));
}
.opacity-10{
  opacity: 0.1;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-4px_6px_-1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 -4px 6px -1px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 -4px 6px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_rgba\\(224\\2c 67\\2c 58\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 0 0 4px rgba(224,67,58,0.2);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_rgba\\(74\\2c 14\\2c 30\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 10px 30px rgba(74,14,30,0.08);
  --tw-shadow-colored: 0 10px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_rgba\\(74\\2c 14\\2c 30\\2c 0\\.15\\)\\]{
  --tw-shadow: 0 10px 30px rgba(74,14,30,0.15);
  --tw-shadow-colored: 0 10px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_12px_rgba\\(74\\2c 14\\2c 30\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 2px 12px rgba(74,14,30,0.04);
  --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_12px_rgba\\(74\\2c 14\\2c 30\\2c 0\\.07\\)\\]{
  --tw-shadow: 0 2px 12px rgba(74,14,30,0.07);
  --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 3px 10px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 3px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 4px 10px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_rgba\\(156\\2c 41\\2c 66\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 4px 12px rgba(156,41,66,0.3);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_rgba\\(156\\2c 41\\2c 66\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 4px 14px rgba(156,41,66,0.3);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_rgba\\(201\\2c 150\\2c 47\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 4px 14px rgba(201,150,47,0.4);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_4px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 4px 4px 0 rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 4px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_4px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 4px 4px 0px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 4px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_6px_-4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\2c 0_10px_15px_-3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 4px 6px -4px rgba(0,0,0,0.1),0 10px 15px -3px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 4px 6px -4px var(--tw-shadow-color), 0 10px 15px -3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_6px_-4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\2c _0_10px_15px_-3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 4px 6px -4px rgba(0,0,0,0.1), 0 10px 15px -3px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 4px 6px -4px var(--tw-shadow-color), 0 10px 15px -3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_10px_-6px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\2c _0_20px_25px_-5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\2c _0_0_0_2px_rgba\\(255\\2c 184\\2c 106\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 8px 10px -6px rgba(0,0,0,0.1), 0 20px 25px -5px rgba(0,0,0,0.1), 0 0 0 2px rgba(255,184,106,0.5);
  --tw-shadow-colored: 0 8px 10px -6px var(--tw-shadow-color), 0 20px 25px -5px var(--tw-shadow-color), 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_10px_-6px_rgba\\(156\\2c 41\\2c 66\\2c 0\\.1\\)\\2c _0_20px_25px_-5px_rgba\\(156\\2c 41\\2c 66\\2c 0\\.1\\)\\2c _0_0_0_2px_rgba\\(156\\2c 41\\2c 66\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 8px 10px -6px rgba(156,41,66,0.1), 0 20px 25px -5px rgba(156,41,66,0.1), 0 0 0 2px rgba(156,41,66,0.3);
  --tw-shadow-colored: 0 8px 10px -6px var(--tw-shadow-color), 0 20px 25px -5px var(--tw-shadow-color), 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[2px_0_16px_rgba\\(74\\2c 14\\2c 30\\2c 0\\.05\\)\\]{
  --tw-shadow: 2px 0 16px rgba(74,14,30,0.05);
  --tw-shadow-colored: 2px 0 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0px_4px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\]{
  --tw-shadow: inset 0px 4px 4px rgba(0,0,0,0.25);
  --tw-shadow-colored: inset 0px 4px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-gray-400{
  --tw-shadow-color: #9ca3af;
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-indigo-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}
.drop-shadow-sm{
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-\\[cubic-bezier\\(0\\.2\\2c 1\\2c 0\\.2\\2c 1\\)\\]{
  transition-timing-function: cubic-bezier(0.2,1,0.2,1);
}
/* SweetAlert2 defaults to z-index 1060, but the complaint modals use z-[9999].
   Without this, confirm dialogs (e.g. "Send BTR for Admin Approval?") open
   behind the modal and can never be clicked, so BTR resubmission silently fails. */
.swal2-container {
  z-index: 100000 !important;
}

/* Override default SweetAlert2 confirm (OK) button color with brand gradient */
.swal2-confirm.swal2-styled {
  background-image: linear-gradient(to right, #45B07B, #12A57C) !important;
  background-color: transparent !important;
  border: none !important;
}

.water-backdrop {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}
.ripple-dot {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(156, 41, 66, 0.15);
  animation: ripple 8s infinite ease-out;
  pointer-events: none;
}
@keyframes ripple {
  0% { transform: scale(0); opacity: 1; }
  100% { transform: scale(3); opacity: 0; }
}
.wave-back, .wave-front {
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 200%;
  height: auto;
}
.wave-back {
  animation: bloomDriftSlow 34s linear infinite;
  opacity: .5;
}
.wave-front {
  animation: bloomDriftSlow 20s linear infinite reverse;
  opacity: .75;
  z-index: 1;
}

@keyframes bloomDriftSlow {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
/* Appended styles from NCW Prototype */
:root {
      /* ===== NCW — "Shakti" Women Empowerment Theme ===== */
      --saffron: #D4A017;
      --saffron-2: #FEF3D0;
      --cream: #FDF4F7;
      --green-accent: #C96A8A;
      --green-accent-2: #FCE8EF;
      --brand-green: #9C2942;
      --brand-green-dark: #7A1A32;
      --brand-teal: #8B1A4A;
      --navy: #5C0F28;
      --navy-dark: #3D0819;
      --text-dark: #2D0F1A;
      --text-mid: #6B3047;
      --text-muted: #A0617A;
      --border: #F0CDD8;
      --surface: #ffffff;
      --page-bg: #FDF0F4;
      --orange-warn: #C1671F;
      --status-open: #D98A20;
      --status-closed: #2D9A6B;

      /* Shakti rose-plum palette */
      --water-deep: #5C0F28;
      --water-mid: #8B1A4A;
      --water-teal: #B5366B;
      --water-cyan: #E8A0B8;
      --water-foam: #FDF0F4;
      --gold: #D4A017;
      --blush-bg: #FCE8EF;
      --rose-light: #FDF0F4;
      --petal-pink: #F5C6D8;
      --deep-rose: #6D1535;

      --radius: 14px;
      --radius-sm: 10px;
      --radius-lg: 20px;
      --shadow: 0 2px 14px rgba(92, 15, 40, 0.08), 0 1px 4px rgba(92, 15, 40, 0.06);
      --shadow-md: 0 10px 32px rgba(92, 15, 40, 0.15);
      --sidebar-w: 250px;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    html,
    body {
      height: 100%;
      overflow: hidden;
    }

    body {
      font-family: 'Inter', system-ui, sans-serif;
      color: var(--text-dark);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      background:
        radial-gradient(1100px 620px at 8% -10%, #F5C6D8 0%, rgba(245, 198, 216, 0) 60%),
        radial-gradient(900px 560px at 105% 8%, #EDB8CE 0%, rgba(237, 184, 206, 0) 55%),
        linear-gradient(180deg, #FDF4F7 0%, #FAEEf2 45%, #F7E4EC 100%);
    }

    /* ============ SITE-WIDE "SHAKTI" BACKDROP ============ */
    .water-backdrop {
      position: fixed;
      inset: 0;
      z-index: 0;
      pointer-events: none;
      overflow: hidden;
    }

    .water-backdrop svg {
      position: absolute;
      left: 0;
      bottom: -2px;
      width: 200%;
      height: auto;
    }

    .water-backdrop .wave-back {
      animation: bloomDriftSlow 34s linear infinite;
      opacity: .5;
    }

    .water-backdrop .wave-front {
      animation: bloomDriftSlow 20s linear infinite reverse;
      opacity: .75;
    }

    @keyframes bloomDriftSlow {
      from {
        transform: translateX(0);
      }

      to {
        transform: translateX(-50%);
      }
    }

    .water-backdrop .ripple-dot {
      position: absolute;
      border-radius: 50%;
      border: 1.5px solid rgba(156, 41, 66, 0.16);
      animation: glowPulse 6s ease-out infinite;
    }

    @keyframes glowPulse {
      0% {
        transform: scale(0.2);
        opacity: .6;
      }

      100% {
        transform: scale(2.2);
        opacity: 0;
      }
    }

    #screen-landing,
    #screen-login,
    #app-shell {
      position: relative;
      z-index: 1;
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    button {
      font-family: inherit;
      cursor: pointer;
      border: none;
      background: none;
    }

    input,
    select,
    textarea {
      font-family: inherit;
      font-size: 14px;
    }

    img {
      max-width: 100%;
      display: block;
    }

    .serif {
      font-family: 'Merriweather', Georgia, serif;
    }

    /* ============ SCREEN SYSTEM ============ */
    .screen {
      display: none;
      height: 100vh;
      overflow: hidden;
    }

    .screen.active {
      display: flex;
      flex-direction: column;
    }

    /* ============ SHARED HEADER ============ */
    .top-header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 34px;
      min-height: 104px;
      background: linear-gradient(120deg, var(--water-deep) 0%, var(--water-mid) 46%, var(--water-teal) 100%);
      border-bottom: 3px solid var(--gold);
      overflow: hidden;
      flex-shrink: 0;
      box-shadow: 0 6px 28px rgba(92, 15, 40, 0.28);
    }

    /* Lotus/Mandala decorative overlay on header */
    .top-header::before {
      content: "";
      position: absolute;
      inset: 0;
      background-image:
        radial-gradient(rgba(255,255,255,0.12) 1.5px, transparent 1.5px),
        radial-gradient(circle at 92% 50%, rgba(212, 160, 23, 0.18) 0%, transparent 50%),
        radial-gradient(circle at 8% 50%, rgba(212, 160, 23, 0.12) 0%, transparent 40%);
      background-size: 22px 22px, 100% 100%, 100% 100%;
      opacity: .85;
      z-index: 0;
    }

    /* Decorative petal arcs on right side of header */
    .top-header::after {
      content: "❀";
      position: absolute;
      right: 200px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 80px;
      color: rgba(255,255,255,0.06);
      z-index: 0;
      pointer-events: none;
      animation: petalSway 8s ease-in-out infinite;
    }

    @keyframes petalSway {
      0%, 100% { transform: translateY(-50%) rotate(-5deg); opacity: 0.06; }
      50% { transform: translateY(-52%) rotate(5deg); opacity: 0.10; }
    }

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;
      position: relative;
      z-index: 2;
    }

    .header-logo {
      width: 78px;
      height: 78px;
      border-radius: 18px;
      background: #fff;
      border: 2px solid rgba(224, 122, 44, 0.35);
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
      flex-shrink: 0;
      padding: 6px;
    }

    .header-logo img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .header-title-block {
      display: flex;
      flex-direction: column;
      gap: 1px;
    }

    .header-title {
      font-size: 15px;
      color: var(--navy);
      letter-spacing: .2px;
      font-weight: 600;
      display: none;
    }

    .header-center {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      z-index: 2;
    }

    .header-center h1 {
      font-size: 30px;
      color: #ffffff;
      letter-spacing: .3px;
      font-weight: 900;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
      font-family: 'Playfair Display', Georgia, serif;
    }

    .header-center span {
      display: block;
      font-size: 11.5px;
      color: var(--water-cyan);
      font-weight: 700;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      margin-top: 2px;
      font-family: 'Inter', sans-serif;
    }

    .header-title {
      color: #fbeef1;
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 14px;
      position: relative;
      z-index: 2;
    }

    .bell-btn {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--orange-warn);
      font-size: 16px;
      box-shadow: var(--shadow);
      position: relative;
    }

    .bell-btn .dot {
      position: absolute;
      top: 8px;
      right: 9px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #e0433a;
    }

    .profile-chip {
      display: flex;
      align-items: center;
      gap: 8px;
      background: #fff;
      border-radius: 999px;
      padding: 6px 14px 6px 6px;
      box-shadow: var(--shadow);
      cursor: pointer;
    }

    .profile-avatar {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: var(--navy);
      color: #fff;
      font-weight: 700;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .profile-name {
      font-weight: 600;
      color: var(--navy);
      font-size: 14px;
    }

    .profile-chip i {
      color: var(--text-muted);
      font-size: 11px;
    }

    .sign-in-btn {
      background: var(--gold);
      color: #fff;
      font-weight: 700;
      font-size: 14px;
      padding: 11px 22px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      gap: 8px;
      box-shadow: 0 4px 14px rgba(201, 150, 47, 0.4);
    }

    .sign-up-btn {
      background: rgba(255, 255, 255, 0.14);
      color: #fff;
      font-weight: 700;
      font-size: 14px;
      padding: 11px 22px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      gap: 8px;
      border: 1.5px solid rgba(255, 255, 255, 0.55);
      backdrop-filter: blur(4px);
    }

    /* ============ WATERMARK BACKDROP ============ */
    .watermark-wrap {
      position: relative;
      flex: 1 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .watermark-wrap .wm-bg-tint {
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.42) 40%, rgba(255, 255, 255, 0.55) 100%);
      pointer-events: none;
    }

    /* ============ LANDING PAGE ============ */
    #screen-landing .landing-body {
      flex: 1 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 70px 90px;
      gap: 40px;
      position: relative;
      z-index: 2;
    }

    .landing-copy {
      max-width: 620px;
      position: relative;
      z-index: 2;
    }

    .landing-copy h1 {
      font-size: 56px;
      line-height: 1.08;
      font-weight: 900;
      background: linear-gradient(90deg, var(--brand-teal), var(--navy));
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      margin-bottom: 16px;
    }

    .landing-copy h2 {
      font-size: 21px;
      font-weight: 800;
      color: #0e2f4d;
      margin-bottom: 14px;
    }

    .landing-copy .eyebrow {
      color: var(--orange-warn);
      font-weight: 800;
      font-size: 17px;
      margin-bottom: 12px;
    }

    .landing-copy p {
      color: var(--text-mid);
      font-size: 15.5px;
      line-height: 1.7;
      margin-bottom: 30px;
      max-width: 540px;
    }

    .landing-btn-row {
      display: flex;
      gap: 16px;
    }

    .landing-visual {
      position: relative;
      width: 460px;
      flex-shrink: 0;
      z-index: 2;
      display: flex;
      justify-content: center;
      padding: 44px 30px 56px;
    }

    .live-updates-card {
      background: #fff;
      border-radius: 22px;
      box-shadow: var(--shadow-md);
      padding: 30px 30px 22px;
      width: 100%;
      max-width: 400px;
    }

    .live-updates-card h4 {
      font-size: 18px;
      margin-bottom: 20px;
      color: #0e2f4d;
      font-weight: 800;
    }

    .lu-item {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 14px 0;
      border-bottom: 1px solid var(--border);
    }

    .lu-item:last-child {
      border-bottom: none;
    }

    .lu-check {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: var(--green-accent-2);
      color: var(--brand-green);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      font-size: 15px;
    }

    .lu-item .lu-text b {
      display: block;
      font-size: 15px;
      font-weight: 700;
      color: #0e2f4d;
      margin-bottom: 2px;
    }

    .lu-item .lu-text small {
      color: var(--text-muted);
      font-size: 12.5px;
    }

    .lu-item .lu-arrow {
      margin-left: auto;
      color: var(--text-muted);
    }

    .mini-card {
      position: absolute;
      background: #fff;
      border-radius: 14px;
      box-shadow: var(--shadow-md);
      padding: 14px 16px;
    }

    .mini-card.chart-icon {
      top: 10px;
      right: 14px;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .mini-card.response-time {
      bottom: 16px;
      left: 10px;
      width: 190px;
    }

    .response-time .rt-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;
    }

    .response-time .rt-top span:first-child {
      font-size: 12px;
      color: var(--text-mid);
      font-weight: 600;
    }

    .response-time .rt-top span:last-child {
      font-size: 15px;
      color: var(--orange-warn);
      font-weight: 800;
    }

    .footer-note {
      text-align: center;
      padding: 14px;
      color: var(--text-muted);
      font-size: 12px;
      border-top: 1px solid var(--border);
      background: #fff;
      position: relative;
      z-index: 3;
    }

    /* ============ LOGIN PAGE ============ */
    #screen-login .login-body {
      flex: 1 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px 20px;
      position: relative;
      z-index: 2;
      max-width: 520px;
      margin: 0 auto;
      width: 100%;
    }

    .login-map {
      display: none !important;
    }

    .login-card {
      background: #fff;
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow-md);
      padding: 40px 52px;
      width: 100%;
      max-width: 520px;
      flex-shrink: 0;
      border-top: 4px solid var(--water-teal);
      position: relative;
    }

    @media (max-width:1100px) {
      .login-body {
        flex-direction: column;
        gap: 24px;
        padding: 20px 30px;
      }

      .login-map {
        width: 100%;
        max-width: 320px;
      }
    }

    @media (max-width:600px) {
      .slot-grid, .vq-grid {
        grid-template-columns: 1fr;
      }
    }

    .login-card h2 {
      text-align: center;
      font-size: 22px;
      color: #0e2f4d;
      margin-bottom: 6px;
    }

    .login-card p.sub {
      text-align: center;
      color: var(--text-muted);
      font-size: 13px;
      margin-bottom: 24px;
    }

    .login-tabs {
      display: flex;
      background: var(--page-bg);
      border-radius: 999px;
      padding: 4px;
      margin-bottom: 22px;
    }

    .login-tabs button {
      flex: 1 1;
      padding: 10px 8px;
      border-radius: 999px;
      font-weight: 700;
      font-size: 13.5px;
      color: var(--text-mid);
      transition: .15s;
    }

    .login-tabs button.active {
      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));
      color: #fff;
      box-shadow: 0 3px 10px rgba(8, 145, 168, 0.3);
    }

    .form-field {
      margin-bottom: 16px;
    }

    .form-field label {
      display: block;
      font-size: 13px;
      font-weight: 600;
      color: #0e2f4d;
      margin-bottom: 6px;
    }

    .form-field label .req {
      color: #e0433a;
    }

    .form-field input,
    .form-field select {
      width: 100%;
      padding: 12px 14px;
      border: 1.5px solid var(--border);
      border-radius: var(--radius-sm);
      font-size: 14px;
      outline: none;
      transition: .15s;
      background: #fff;
    }

    .form-field input:focus,
    .form-field select:focus {
      border-color: var(--brand-teal);
    }

    .check-row {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: var(--text-mid);
      margin-bottom: 20px;
    }

    .btn-primary-full {
      width: 100%;
      padding: 13px;
      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));
      color: #fff;
      font-weight: 700;
      font-size: 15px;
      border-radius: var(--radius-sm);
      box-shadow: 0 4px 14px rgba(8, 145, 168, 0.28);
      margin-bottom: 12px;
    }

    .btn-secondary-full {
      width: 100%;
      padding: 13px;
      background: var(--page-bg);
      color: var(--navy);
      font-weight: 700;
      font-size: 14.5px;
      border-radius: var(--radius-sm);
      border: 1.5px solid var(--border);
    }

    .login-terms {
      text-align: center;
      color: var(--text-muted);
      font-size: 11.5px;
      margin-top: 16px;
    }

    /* ============ APP SHELL ============ */
    #app-shell {
      display: none;
      height: 100vh;
      flex-direction: column;
    }

    #app-shell.active {
      display: flex;
    }

    .app-body {
      flex: 1 1;
      display: flex;
      position: relative;
      overflow: hidden;
      min-height: 0;
    }

    .sidebar {
      width: var(--sidebar-w);
      background: linear-gradient(180deg, #ffffff 0%, var(--water-foam) 100%);
      border-right: 1px solid var(--border);
      padding: 20px 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex-shrink: 0;
      position: relative;
      z-index: 5;
      box-shadow: 2px 0 16px rgba(74, 14, 30, 0.05);
    }

    .nav-btn {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 13px 16px;
      border-radius: var(--radius-sm);
      font-weight: 700;
      font-size: 14px;
      color: var(--navy);
      border: 1.5px solid var(--border);
      text-align: left;
      transition: .15s;
    }

    .nav-btn i {
      width: 16px;
      text-align: center;
    }

    .nav-btn:hover {
      border-color: var(--brand-green);
    }

    .nav-btn.active {
      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));
      color: #fff;
      border-color: transparent;
      box-shadow: 0 4px 14px rgba(8, 145, 168, 0.3);
    }

    .sidebar-spacer {
      flex: 1 1;
    }

    .sidebar-map {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      padding: 16px 10px 18px;
      margin: 8px 10px;
      position: relative;
      background: rgba(23, 52, 140, 0.04);
      border-radius: 14px;
      border: 1.5px solid rgba(23, 52, 140, 0.08);
    }

    .sidebar-map img {
      width: 148px;
      max-width: 90%;
      mix-blend-mode: multiply;
      opacity: .9;
      display: block;
    }

    .sidebar-map .tag-line {
      font-size: 10px;
      color: var(--brand-teal);
      font-weight: 700;
      letter-spacing: 1.1px;
      text-align: center;
    }

    .btn-feedback {
      background: linear-gradient(100deg, var(--brand-green), var(--brand-teal));
      color: #fff;
      font-weight: 700;
      padding: 13px 16px;
      border-radius: var(--radius-sm);
      display: flex;
      align-items: center;
      gap: 8px;
      justify-content: center;
      box-shadow: 0 4px 14px rgba(21, 154, 92, 0.24);
    }

    .btn-logout {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 13px 16px;
      border-radius: var(--radius-sm);
      font-weight: 700;
      font-size: 14px;
      color: #9c2942;
      background: #f7eef0;
      border: 1.5px solid #9c2942;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
      box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    }

    .btn-logout:hover {
      color: #ffffff;
      background: #9c2942;
      border-color: #9c2942;
    }

    .main-content {
      flex: 1 1;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    .main-content .watermark-wrap {
      overflow: visible;
      flex: none;
      min-height: 100%;
    }

    .view {
      display: none;
      flex: 1 1;
      flex-direction: column;
      min-height: 0;
    }

    .view.active {
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    /* ============ CHATBOT VIEW ============ */
    .chat-topbar {
      padding: 14px 30px;
      border-bottom: 1px solid var(--border);
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      z-index: 3;
    }

    .chat-topbar p {
      color: var(--text-mid);
      font-size: 13.5px;
    }

    .lang-select {
      border: 1.5px solid var(--border);
      border-radius: var(--radius-sm);
      padding: 6px 10px;
      font-size: 13px;
      color: var(--text-mid);
      flex-shrink: 0;
      margin-left: 16px;
    }

    .marquee-wrap {
      flex: 1 1;
      overflow: hidden;
      white-space: nowrap;
      position: relative;
      mask-image: linear-gradient(90deg, transparent, #000 4%, #000 96%, transparent);
      -webkit-mask-image: linear-gradient(90deg, transparent, #000 4%, #000 96%, transparent);
    }

    .marquee-text {
      display: inline-block;
      padding-left: 100%;
      animation: marquee-scroll 22s linear infinite;
      color: var(--text-mid);
      font-size: 13.5px;
    }

    @keyframes marquee-scroll {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(-100%);
      }
    }

    .sample-query-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      max-width: 640px;
    }

    .chat-scroll {
      flex: 1 1;
      overflow-y: auto;
      padding: 34px 40px;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    .chat-empty-state {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 22px;
      text-align: center;
      position: relative;
      z-index: 2;
    }

    .mic-orb {
      width: 110px;
      height: 110px;
      border-radius: 50%;
      background: #fff;
      border: 5px solid var(--orange-warn);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 34px;
      color: var(--text-mid);
      box-shadow: var(--shadow-md);
    }

    .chat-empty-state h3 {
      font-size: 20px;
      color: #0e2f4d;
      font-weight: 800;
    }

    .sample-query {
      background: #fff;
      border-radius: var(--radius);
      box-shadow: var(--shadow);
      padding: 18px 22px;
      max-width: 560px;
      color: var(--text-mid);
      font-size: 14px;
      line-height: 1.6;
      cursor: pointer;
      border: 1.5px dashed var(--border);
    }

    .sample-query:hover {
      border-color: var(--brand-teal);
    }

    .msg-row {
      display: flex;
      gap: 12px;
      max-width: 78%;
      position: relative;
      z-index: 2;
    }

    .msg-row.bot {
      align-self: flex-start;
    }

    .msg-row.user {
      align-self: flex-end;
      flex-direction: row-reverse;
    }

    .msg-avatar {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #fff;
      font-weight: 700;
    }

    .msg-row.bot .msg-avatar {
      background: linear-gradient(135deg, var(--orange-warn), var(--saffron));
    }

    .msg-row.user .msg-avatar {
      background: var(--navy);
    }

    .msg-bubble {
      background: #fff;
      border-radius: 14px;
      padding: 14px 18px;
      box-shadow: var(--shadow);
      font-size: 14px;
      line-height: 1.65;
      color: var(--text-dark);
    }

    .msg-row.user .msg-bubble {
      background: #fff5e9;
    }

    .msg-bubble .msg-actions {
      display: flex;
      gap: 10px;
      margin-top: 8px;
      color: var(--text-muted);
      font-size: 12px;
    }

    .msg-bubble .msg-actions i {
      cursor: pointer;
    }

    .summary-card {
      background: #fff;
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow-md);
      overflow: hidden;
      max-width: 640px;
      align-self: flex-start;
      position: relative;
      z-index: 2;
    }

    .summary-header {
      background: linear-gradient(100deg, var(--brand-teal), var(--brand-green));
      color: #fff;
      padding: 14px 22px;
      font-weight: 800;
      font-size: 15px;
    }

    .summary-body {
      padding: 20px 22px;
    }

    .summary-body>p {
      color: var(--text-dark);
      font-size: 13.8px;
      line-height: 1.7;
      margin-bottom: 16px;
    }

    .summary-table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 16px;
    }

    .summary-table td {
      padding: 9px 4px;
      border-bottom: 1px solid var(--border);
      font-size: 13.5px;
    }

    .summary-table td:first-child {
      color: var(--text-muted);
      font-weight: 600;
      width: 38%;
    }

    .summary-table td:last-child {
      color: #0e2f4d;
      font-weight: 600;
    }

    .dept-chip {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: var(--green-accent-2);
      color: var(--brand-green-dark);
      padding: 4px 12px;
      border-radius: 999px;
      font-weight: 700;
      font-size: 13px;
    }

    .change-dept-btn {
      color: var(--brand-teal);
      font-weight: 700;
      font-size: 13px;
      border: 1.5px solid var(--brand-teal);
      padding: 8px 14px;
      border-radius: var(--radius-sm);
      margin-bottom: 14px;
    }

    .dept-list {
      display: none;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 16px;
      background: var(--page-bg);
      border-radius: var(--radius-sm);
      padding: 12px;
    }

    .dept-list.show {
      display: flex;
    }

    .dept-option {
      padding: 10px 14px;
      border-radius: var(--radius-sm);
      border: 1.5px solid var(--border);
      background: #fff;
      font-size: 13.5px;
      font-weight: 600;
      color: var(--text-dark);
      text-align: left;
    }

    .dept-option:hover {
      border-color: var(--brand-teal);
    }

    .dept-option.selected {
      border-color: var(--brand-green);
      background: var(--green-accent-2);
      color: var(--brand-green-dark);
    }

    .summary-body p.hint {
      color: var(--text-mid);
      font-size: 13px;
      line-height: 1.6;
      margin-bottom: 16px;
    }

    .summary-actions {
      display: flex;
      gap: 10px;
    }

    .btn-like,
    .btn-dislike {
      padding: 9px 16px;
      border-radius: var(--radius-sm);
      font-weight: 700;
      font-size: 13px;
      border: 1.5px solid var(--border);
      display: flex;
      align-items: center;
      gap: 6px;
      color: var(--text-mid);
    }

    .btn-like.active {
      background: var(--green-accent-2);
      color: var(--brand-green-dark);
      border-color: var(--brand-green);
    }

    .btn-dislike.active {
      background: #fde3e1;
      color: #c8382c;
      border-color: #e0433a;
    }

    .btn-submit-grievance {
      margin-left: auto;
      padding: 9px 22px;
      border-radius: var(--radius-sm);
      font-weight: 700;
      font-size: 13px;
      background: var(--brand-green);
      color: #fff;
      box-shadow: 0 4px 12px rgba(21, 154, 92, 0.3);
    }

    .chat-input-bar {
      padding: 16px 30px 22px;
      background: transparent;
      position: relative;
      z-index: 3;
    }

    .chat-input-inner {
      display: flex;
      align-items: center;
      gap: 10px;
      background: #fff;
      border-radius: 999px;
      box-shadow: var(--shadow-md);
      padding: 8px 8px 8px 18px;
    }

    .chat-input-inner input {
      flex: 1 1;
      border: none;
      outline: none;
      font-size: 14px;
      background: transparent;
    }

    .icon-btn {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--orange-warn);
      font-size: 15px;
      flex-shrink: 0;
      transition: .15s;
    }

    .icon-btn.recording {
      background: #fde3e1;
      color: #e0433a;
      animation: pulse 1s infinite;
    }

    @keyframes pulse {
      0% {
        box-shadow: 0 0 0 0 rgba(224, 67, 58, .4);
      }

      70% {
        box-shadow: 0 0 0 9px rgba(224, 67, 58, 0);
      }

      100% {
        box-shadow: 0 0 0 0 rgba(224, 67, 58, 0);
      }
    }

    .send-btn {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      background: var(--brand-green);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      flex-shrink: 0;
      box-shadow: 0 4px 12px rgba(21, 154, 92, 0.3);
    }

    .typing-indicator {
      display: flex;
      gap: 4px;
      align-items: center;
      padding: 14px 18px;
    }

    .typing-indicator span {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: var(--text-muted);
      animation: blink 1.2s infinite ease-in-out;
    }

    .typing-indicator span:nth-child(2) {
      animation-delay: .2s;
    }

    .typing-indicator span:nth-child(3) {
      animation-delay: .4s;
    }

    @keyframes blink {

      0%,
      80%,
      100% {
        opacity: .25;
      }

      40% {
        opacity: 1;
      }
    }

    @keyframes orbPulse {

      0%,
      100% {
        box-shadow: 0 0 0 8px rgba(14, 158, 143, 0.2);
      }

      50% {
        box-shadow: 0 0 0 18px rgba(14, 158, 143, 0.05);
      }
    }

    /* ============ DASHBOARD (USER) ============ */
    .view-inner {
      padding: 28px 36px 40px;
      flex: 1 1;
      position: relative;
      z-index: 2;
    }

    .view-inner h2.page-title {
      font-size: 20px;
      color: #0e2f4d;
      margin-bottom: 20px;
      font-weight: 800;
    }

    .stat-cards {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      margin-bottom: 24px;
    }

    .stat-card {
      border-radius: var(--radius-lg);
      padding: 22px 24px;
      color: #fff;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      gap: 10px;
      box-shadow: var(--shadow-md);
    }

    .stat-card.c1 {
      background: linear-gradient(135deg, #8B1A4A, #5C0F28);
    }

    .stat-card.c2 {
      background: linear-gradient(135deg, #D4A017, #A57A0E);
    }

    .stat-card.c3 {
      background: linear-gradient(135deg, #B5366B, #8B1A4A);
    }

    .stat-card .top-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .stat-card .top-row span {
      font-weight: 700;
      font-size: 13.5px;
      max-width: 75%;
      line-height: 1.4;
    }

    .stat-card .icon-circle {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.22);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
    }

    .stat-card .stat-num {
      font-size: 34px;
      font-weight: 900;
    }

    .card {
      background: #fff;
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow);
      padding: 22px;
      border: 1px solid var(--border);
      position: relative;
      overflow: hidden;
    }

    /* Subtle lotus watermark on cards */
    .card::before {
      content: "✿";
      position: absolute;
      bottom: -12px;
      right: -8px;
      font-size: 72px;
      color: rgba(181, 54, 107, 0.04);
      pointer-events: none;
      z-index: 0;
    }

    .card h3 {
      font-size: 15.5px;
      margin-bottom: 16px;
      color: var(--navy);
      font-family: 'Playfair Display', serif;
      position: relative;
      z-index: 1;
    }

    .grid-2 {
      display: grid;
      grid-template-columns: 1.1fr 1.4fr;
      gap: 20px;
      margin-bottom: 24px;
    }

    .grid-2b {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
      margin-bottom: 24px;
    }

    .search-bar {
      width: 100%;
      max-width: 320px;
      padding: 11px 14px;
      border: 1.5px solid var(--border);
      border-radius: var(--radius-sm);
      margin-bottom: 18px;
      font-size: 13.5px;
    }

    table.data-table {
      width: 100%;
      border-collapse: collapse;
    }

    table.data-table th {
      position: sticky;
      top: 0;
      background: linear-gradient(90deg, #FDF0F4 0%, #FAE8F0 100%);
      z-index: 5;
      text-align: left;
      font-size: 12px;
      color: var(--navy);
      padding: 10px 12px;
      border-bottom: 2px solid var(--petal-pink);
      text-transform: uppercase;
      letter-spacing: .6px;
      font-weight: 700;
    }

    table.data-table td {
      padding: 13px 12px;
      border-bottom: 1px solid var(--border);
      font-size: 13.5px;
      color: var(--text-dark);
    }

    table.data-table td.grid-id {
      color: var(--brand-teal);
      font-weight: 700;
    }

    .status-badge {
      padding: 5px 14px;
      border-radius: 999px;
      font-weight: 700;
      font-size: 12px;
      color: #fff;
      display: inline-block;
    }

    .status-badge.open {
      background: linear-gradient(135deg, #D98A20, #B5700D);
    }

    .status-badge.closed,
    .status-badge.resolved {
      background: linear-gradient(135deg, #2D9A6B, #1F7050);
    }

    .status-badge.in-progress {
      background: linear-gradient(135deg, #4A6FC8, #2D4FA0);
    }

    .status-filter {
      border: 1.5px solid var(--border);
      border-radius: var(--radius-sm);
      padding: 6px 10px;
      font-size: 12.5px;
    }

    .view-eye {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: var(--green-accent-2);
      color: var(--brand-green-dark);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /* ============ SORTABLE TABLE HEADERS (officer view) ============ */
    table.data-table th.sortable {
      cursor: pointer;
      -webkit-user-select: none;
              user-select: none;
      white-space: nowrap;
    }

    table.data-table th.sortable i {
      margin-left: 5px;
      font-size: 10px;
      color: var(--text-muted);
    }

    table.data-table th.sortable.sort-active i {
      color: var(--brand-teal);
    }

    .officer-toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;
      margin-bottom: 16px;
    }

    .officer-toolbar .search-bar {
      margin-bottom: 0;
    }

    /* Officer mid-grid: pie chart + overdue side by side */
    .officer-mid-grid {
      display: grid;
      grid-template-columns: 260px 1fr;
      gap: 20px;
      margin-top: 20px;
    }

    .officer-chart-card {
      min-height: 240px;
    }

    .officer-overdue-card {
      overflow: hidden;
    }

    /* Add Comment button — amber/gold like the screenshot */
    .officer-add-comment-btn {
      background: #e8a53d;
      color: #fff;
      font-size: 11.5px;
      font-weight: 700;
      padding: 5px 12px;
      border-radius: 6px;
      border: none;
      cursor: pointer;
      white-space: nowrap;
      transition: background .15s;
    }

    .officer-add-comment-btn:hover {
      background: #d4912a;
    }

    /* Comment pill — shown when comment has been saved */
    .officer-comment-pill {
      display: inline-block;
      background: #f0faf5;
      color: #0e7a48;
      font-size: 11px;
      font-weight: 600;
      padding: 4px 10px;
      border-radius: 6px;
      border: 1.5px solid rgba(21, 154, 92, 0.3);
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: default;
    }

    /* Resolved status badge */
    .status-badge.resolved {
      background: rgba(21, 154, 92, 0.12);
      color: #0e7a48;
    }

    /* ============ ROTATING SUGGESTED QUESTION ============ */
    .suggest-box {
      background: #fff;
      border-radius: var(--radius);
      box-shadow: var(--shadow);
      padding: 18px 22px;
      max-width: 560px;
      color: var(--text-mid);
      font-size: 14px;
      line-height: 1.6;
      cursor: pointer;
      border: 1.5px dashed var(--border);
      position: relative;
      min-height: 56px;
      display: flex;
      align-items: center;
    }

    .suggest-box:hover {
      border-color: var(--brand-teal);
    }

    .suggest-box .suggest-label {
      position: absolute;
      top: -11px;
      left: 16px;
      background: var(--brand-teal);
      color: #fff;
      font-size: 10.5px;
      font-weight: 700;
      letter-spacing: .4px;
      padding: 3px 10px;
      border-radius: 999px;
      text-transform: uppercase;
    }

    .suggest-box .suggest-text {
      transition: opacity .25s ease;
    }

    .suggest-box .suggest-text.fade {
      opacity: 0;
    }

    /* ============ MODALS ============ */
    .modal-overlay {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(15, 25, 45, 0.5);
      z-index: 100;
      align-items: center;
      justify-content: center;
      padding: 20px;
    }

    .modal-overlay.show {
      display: flex;
    }

    .modal-box {
      background: #fff;
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow-md);
      max-width: 520px;
      width: 100%;
      max-height: 88vh;
      overflow-y: auto;
      position: relative;
    }

    .modal-box.wide {
      max-width: 760px;
    }

    .modal-close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: var(--page-bg);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--text-mid);
      font-size: 14px;
      z-index: 2;
    }

    .modal-close:hover {
      background: #f0d9d8;
      color: #c8382c;
    }

    .success-modal-body {
      padding: 46px 40px 38px;
      text-align: center;
    }

    .success-check {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: var(--green-accent-2);
      color: var(--brand-green);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 36px;
      margin: 0 auto 20px;
    }

    .success-modal-body h3 {
      font-size: 20px;
      color: #0e2f4d;
      margin-bottom: 10px;
    }

    .success-modal-body p {
      color: var(--text-mid);
      font-size: 14px;
      margin-bottom: 4px;
    }

    .success-modal-body .grievance-id-box {
      display: inline-block;
      margin: 14px 0 26px;
      background: var(--page-bg);
      border: 1.5px dashed var(--brand-green);
      border-radius: var(--radius-sm);
      padding: 10px 22px;
      font-weight: 800;
      color: var(--brand-green-dark);
      font-size: 16px;
    }

    .success-modal-body .btn-row {
      display: flex;
      gap: 12px;
    }

    .success-modal-body .btn-row button {
      flex: 1 1;
      padding: 13px;
      border-radius: var(--radius-sm);
      font-weight: 700;
      font-size: 14px;
    }

    .btn-ok {
      background: var(--page-bg);
      color: var(--navy);
      border: 1.5px solid var(--border);
    }

    .btn-dash {
      background: var(--brand-green);
      color: #fff;
      box-shadow: 0 4px 14px rgba(21, 154, 92, 0.3);
    }

    .view-query-header {
      padding: 22px 26px;
      border-bottom: 1px solid var(--border);
    }

    .view-query-header h3 {
      font-size: 18px;
      color: #0e2f4d;
    }

    .view-query-body {
      padding: 22px 26px;
    }

    .vq-label {
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: .5px;
      color: var(--text-muted);
      font-weight: 700;
      margin-bottom: 6px;
      margin-top: 18px;
    }

    .vq-label:first-child {
      margin-top: 0;
    }

    .vq-text {
      font-size: 14px;
      color: var(--text-dark);
      line-height: 1.65;
    }

    .vq-comment-box {
      background: var(--page-bg);
      border-radius: var(--radius-sm);
      padding: 14px;
      color: var(--text-muted);
      font-size: 13.5px;
      font-style: italic;
    }

    .vq-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      margin-top: 18px;
    }

    .vq-field label {
      display: block;
      font-size: 11.5px;
      text-transform: uppercase;
      color: var(--text-muted);
      font-weight: 700;
      margin-bottom: 5px;
    }

    .vq-field .val {
      font-size: 13.8px;
      font-weight: 600;
      color: #0e2f4d;
    }

    /* ============ AI COMPLAINT SUMMARY ============ */
    .ai-section-title {
      font-size: 12px;
      font-weight: 800;
      letter-spacing: .06em;
      text-transform: uppercase;
      color: var(--text-muted);
      margin: 22px 0 8px;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .ai-section-title:first-child {
      margin-top: 0;
    }

    .ai-section-title i {
      color: var(--brand-teal);
    }

    .ai-badge {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      background: var(--green-accent-2);
      color: var(--brand-teal);
      border: 1px solid var(--brand-teal);
      font-size: 10.5px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: .04em;
      padding: 3px 9px;
      border-radius: 999px;
      margin-left: 8px;
    }

    .ai-summary-card {
      background: var(--page-bg);
      border-left: 4px solid var(--brand-teal);
      border-radius: var(--radius-sm);
      padding: 14px 16px;
      font-size: 13.5px;
      line-height: 1.7;
      color: var(--text-dark);
    }

    .raw-input-toggle {
      cursor: pointer;
      color: var(--brand-teal);
      font-weight: 700;
      font-size: 13px;
      margin: 14px 0 6px;
      display: flex;
      align-items: center;
      gap: 6px;
      -webkit-user-select: none;
              user-select: none;
    }

    .raw-input-toggle i {
      transition: transform .2s ease;
      font-size: 11px;
    }

    .raw-input-toggle.open i {
      transform: rotate(180deg);
    }

    .raw-input-box {
      background: var(--blush-bg, #f7eef0);
      border: 1px solid var(--border);
      border-radius: var(--radius-sm);
      padding: 12px 14px;
      font-size: 13px;
      color: var(--text-mid);
      display: none;
      line-height: 1.6;
    }

    .raw-input-box.open {
      display: block;
    }

    .slot-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      margin-top: 10px;
    }

    .slot-field {
      background: var(--surface);
      border: 1px solid var(--border);
      border-left: 3px solid var(--gold);
      border-radius: var(--radius-sm);
      padding: 10px 12px;
    }

    .slot-field label {
      display: block;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: .04em;
      color: var(--text-muted);
      font-weight: 700;
      margin-bottom: 4px;
    }

    .slot-field .val {
      font-weight: 700;
      color: var(--text-dark);
      font-size: 13.8px;
    }

    /* ============ BTR (BRIEF TRANSMISSION REPORT) ============ */
    .btr-panel {
      background: var(--surface);
      border: 1.5px solid var(--border);
      border-radius: var(--radius);
      padding: 16px 18px;
      margin-top: 6px;
    }

    .btr-panel textarea {
      width: 100%;
      min-height: 80px;
      border: 1.5px solid var(--border);
      border-radius: var(--radius-sm);
      padding: 10px 12px;
      font-size: 13.3px;
      font-family: inherit;
      line-height: 1.6;
      resize: vertical;
      color: var(--text-dark);
      background: var(--page-bg);
    }

    .btr-panel textarea:disabled {
      background: #f1eaeb;
      color: var(--text-mid);
      cursor: not-allowed;
    }

    .btr-field-label {
      font-size: 12px;
      font-weight: 800;
      color: var(--text-mid);
      margin: 14px 0 6px;
      text-transform: uppercase;
      letter-spacing: .03em;
    }

    .btr-field-label:first-child {
      margin-top: 0;
    }

    .btr-chrono-list {
      list-style: none;
      padding: 0;
      margin: 4px 0 0;
    }

    .btr-chrono-list li {
      position: relative;
      padding: 6px 0 6px 20px;
      font-size: 13.2px;
      color: var(--text-dark);
      border-left: 2px solid var(--brand-teal);
      margin-left: 4px;
    }

    .btr-chrono-list li::before {
      content: "";
      position: absolute;
      left: -5px;
      top: 12px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: var(--brand-teal);
    }

    .btr-status-pill {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 11.5px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: .04em;
      padding: 4px 12px;
      border-radius: 999px;
    }

    .btr-status-pill.draft {
      background: #f3e4c0;
      color: #8a5f10;
    }

    .btr-status-pill.submitted {
      background: var(--green-accent-2);
      color: var(--brand-teal);
    }

    .btr-status-pill.approved {
      background: #d9f2e6;
      color: var(--brand-green-dark);
    }

    .btr-status-pill.returned {
      background: #fbdede;
      color: #a12626;
    }

    .btr-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-top: 16px;
    }

    .btr-btn {
      border: none;
      border-radius: 8px;
      padding: 9px 18px;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
    }

    .btr-btn.ai {
      background: var(--surface);
      border: 1.5px solid var(--brand-teal);
      color: var(--brand-teal);
    }

    .btr-btn.save {
      background: var(--page-bg);
      border: 1.5px solid var(--border);
      color: var(--text-dark);
    }

    .btr-btn.submit {
      background: var(--brand-teal);
      color: #fff;
    }

    .btr-btn.approve {
      background: var(--brand-green);
      color: #fff;
    }

    .btr-btn.return {
      background: #fff;
      border: 1.5px solid #c1671f;
      color: #c1671f;
    }

    .btr-btn:disabled {
      opacity: .5;
      cursor: not-allowed;
    }

    .vq-footer {
      padding: 18px 26px;
      border-top: 1px solid var(--border);
      display: flex;
      justify-content: flex-end;
    }

    .btn-close-modal {
      background: var(--page-bg);
      color: var(--navy);
      font-weight: 700;
      padding: 10px 26px;
      border-radius: var(--radius-sm);
      border: 1.5px solid var(--border);
    }

    .feedback-body {
      padding: 34px 32px 30px;
      text-align: center;
    }

    .feedback-body h3 {
      font-size: 18px;
      color: #0e2f4d;
      margin-bottom: 24px;
    }

    .star-row {
      display: flex;
      justify-content: center;
      gap: 14px;
      margin-bottom: 8px;
    }

    .star-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      cursor: pointer;
    }

    .star-item i {
      font-size: 26px;
      color: #dbe0e6;
      transition: .15s;
    }

    .star-item span {
      font-size: 11px;
      color: var(--text-muted);
      font-weight: 600;
    }

    .star-item.active i,
    .star-item.filled i {
      color: #f0a63c;
    }

    .feedback-body textarea {
      width: 100%;
      min-height: 100px;
      border: 1.5px solid var(--border);
      border-radius: var(--radius-sm);
      padding: 14px;
      font-size: 13.5px;
      margin: 22px 0 20px;
      outline: none;
      resize: vertical;
    }

    .feedback-body textarea:focus {
      border-color: var(--brand-teal);
    }

    .btn-submit-fb {
      width: 100%;
      padding: 13px;
      background: var(--brand-green);
      color: #fff;
      font-weight: 700;
      border-radius: var(--radius-sm);
      box-shadow: 0 4px 14px rgba(21, 154, 92, 0.28);
    }

    /* ============ REGISTER OFFICER ============ */
    .register-card {
      background: #fff;
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow);
      max-width: 900px;
      margin: 34px auto;
      padding: 40px 46px;
      position: relative;
      z-index: 2;
    }

    .register-card h2 {
      text-align: center;
      color: var(--brand-green-dark);
      font-size: 22px;
      margin-bottom: 6px;
    }

    .register-card p.sub {
      text-align: center;
      color: var(--text-muted);
      font-size: 13.5px;
      margin-bottom: 30px;
    }

    .form-grid-2 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px 26px;
      margin-bottom: 26px;
    }

    .register-btn-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }

    .btn-back {
      background: #7c8695;
      color: #fff;
      font-weight: 700;
      padding: 13px;
      border-radius: var(--radius-sm);
    }

    .btn-register {
      background: linear-gradient(100deg, var(--brand-teal), var(--brand-green));
      color: #fff;
      font-weight: 700;
      padding: 13px;
      border-radius: var(--radius-sm);
      box-shadow: 0 4px 14px rgba(21, 154, 92, 0.3);
    }

    .officer-list-card {
      max-width: 900px;
      margin: 0 auto 34px;
      position: relative;
      z-index: 2;
    }

    /* ============ EMPTY STATE (Officer) ============ */
    .empty-state {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      text-align: center;
      position: relative;
      z-index: 2;
      padding: 40px;
    }

    .empty-state .icon {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      background: var(--green-accent-2);
      color: var(--brand-green);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 34px;
    }

    .empty-state h3 {
      font-size: 19px;
      color: #0e2f4d;
    }

    .empty-state p {
      color: var(--text-mid);
      font-size: 13.8px;
      max-width: 400px;
      line-height: 1.6;
    }

    /* ============ TOAST ============ */
    .toast {
      position: fixed;
      bottom: 26px;
      left: 50%;
      transform: translateX(-50%) translateY(20px);
      background: #0e2f4d;
      color: #fff;
      padding: 13px 26px;
      border-radius: 999px;
      font-size: 13.5px;
      font-weight: 600;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
      z-index: 200;
      opacity: 0;
      pointer-events: none;
      transition: .25s;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .toast.show {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }

    .toast i {
      color: #3ecf8e;
    }

    /* misc */
    .chart-scroll-wrap {
      overflow-x: auto;
    }

    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }

    ::-webkit-scrollbar-track {
      background: var(--rose-light);
    }

    ::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, var(--water-teal), var(--water-mid));
      border-radius: 4px;
    }

    /* ===== Women-Empowerment Empowerment Tag decorations ===== */
    .empowerment-tag {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: linear-gradient(90deg, var(--water-deep), var(--water-teal));
      color: #fff;
      font-size: 10px;
      font-weight: 800;
      letter-spacing: 1.2px;
      text-transform: uppercase;
      padding: 4px 12px;
      border-radius: 999px;
    }

    /* Lotus animation for empty states */
    @keyframes lotusBloom {
      0% { transform: scale(0.95) rotate(-3deg); opacity: 0.7; }
      50% { transform: scale(1.05) rotate(3deg); opacity: 1; }
      100% { transform: scale(0.95) rotate(-3deg); opacity: 0.7; }
    }

    .empty-state .icon {
      animation: lotusBloom 3s ease-in-out infinite;
      background: linear-gradient(135deg, var(--blush-bg), var(--water-foam));
      color: var(--brand-teal);
    }

    /* Page titles — Playfair Display for elegance */
    .view-inner h2.page-title,
    .register-card h2,
    .live-updates-card h4 {
      font-family: 'Playfair Display', Georgia, serif;
      color: var(--navy);
    }

    /* Login card top border — rose gradient */
    .login-card {
      border-top: 4px solid transparent;
      background-clip: padding-box;
      position: relative;
    }
    .login-card::before {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0;
      height: 4px;
      background: linear-gradient(90deg, var(--water-deep), var(--water-teal), var(--gold));
      border-radius: var(--radius-lg) var(--radius-lg) 0 0;
      z-index: 1;
    }

    /* SweetAlert2 button — rose gradient */
    .swal2-confirm.swal2-styled {
      background-image: linear-gradient(to right, var(--water-teal), var(--water-mid)) !important;
      background-color: transparent !important;
      border: none !important;
    }

    /* BTR panel accent — rose border */
    .btr-chrono-list li {
      border-left: 2px solid var(--water-teal);
    }
    .btr-chrono-list li::before {
      background: var(--water-teal);
    }

    /* Ripple dots — rose tones */
    .ripple-dot {
      border: 1px solid rgba(181, 54, 107, 0.18);
    }

    /* Nav active button — rose gradient */
    .nav-btn.active {
      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));
      color: #fff;
      border-color: transparent;
      box-shadow: 0 4px 14px rgba(139, 26, 74, 0.32);
    }

    /* Register button — rose gradient */
    .btn-register {
      background: linear-gradient(100deg, var(--water-teal), var(--water-mid));
      color: #fff;
      font-weight: 700;
      padding: 13px;
      border-radius: var(--radius-sm);
      box-shadow: 0 4px 14px rgba(139, 26, 74, 0.30);
    }

    /* Send button — rose */
    .send-btn {
      background: linear-gradient(135deg, var(--water-teal), var(--water-mid));
      box-shadow: 0 4px 14px rgba(139, 26, 74, 0.32);
    }

    /* Sample query hover */
    .sample-query:hover,
    .suggest-box:hover {
      border-color: var(--water-teal);
      background: #FDF0F4;
    }

    /* Suggest label pill */
    .suggest-box .suggest-label {
      background: var(--water-teal);
    }

    /* AI summary border */
    .ai-summary-card {
      border-left: 4px solid var(--water-teal);
      background: var(--blush-bg);
    }

    /* BTR btn — rose accents */
    .btr-btn.submit, .btr-btn.ai {
      border-color: var(--water-teal);
      color: var(--water-teal);
    }
    .btr-btn.submit {
      background: var(--water-teal);
      color: #fff;
    }

    /* Feedback submit button */
    .btn-submit-fb, .btn-dash {
      background: linear-gradient(135deg, var(--water-teal), var(--water-mid));
      box-shadow: 0 4px 14px rgba(139, 26, 74, 0.28);
    }

    /* Table row hover — soft rose tint */
    table.data-table tbody tr:hover {
      background: #FDF0F4;
      transition: background 0.15s ease;
    }

    /* Table alternate rows */
    table.data-table tbody tr:nth-child(even) {
      background: #FEFBFC;
    }

    /* Tooltip / popover — rose background */
    .btr-status-pill.submitted {
      background: var(--blush-bg);
      color: var(--water-teal);
      border: 1px solid var(--water-teal);
    }

    /* Primary full button */
    .btn-primary-full {
      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));
    }

    /* Login tab active */
    .login-tabs button.active {
      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));
      box-shadow: 0 3px 10px rgba(139, 26, 74, 0.3);
    }

    /* Profile avatar */
    .profile-avatar {
      background: linear-gradient(135deg, var(--water-teal), var(--water-mid));
    }

    /* Floating lotus decoration for dashboard */
    @keyframes floatLotus {
      0%, 100% { transform: translateY(0px) rotate(0deg); }
      33% { transform: translateY(-8px) rotate(3deg); }
      66% { transform: translateY(-4px) rotate(-2deg); }
    }
    .lotus-float {
      animation: floatLotus 6s ease-in-out infinite;
      display: inline-block;
    }

    /* Mic orb — rose */
    .mic-orb {
      border-color: var(--water-teal);
    }

    /* Success check — rose */
    .success-check {
      background: var(--blush-bg);
      color: var(--water-teal);
    }

    /* User message bubble — soft rose */
    .msg-row.user .msg-bubble {
      background: linear-gradient(135deg, #FCE8EF, #FDF0F4);
    }

    /* Dept chip */
    .dept-chip {
      background: var(--blush-bg);
      color: var(--water-mid);
    }

    /* Logout button — rose */
    .btn-logout {
      color: var(--water-teal);
      background: #FCE8EF;
      border: 1.5px solid var(--water-teal);
    }
    .btn-logout:hover {
      color: #fff;
      background: var(--water-teal);
      border-color: var(--water-teal);
    }

    /* Sidebar */
    .sidebar {
      background: linear-gradient(180deg, #ffffff 0%, #FDF0F4 100%);
      border-right: 1px solid var(--border);
    }

    /* nav-btn hover — rose */
    .nav-btn:hover {
      border-color: var(--water-teal);
      background: #FCE8EF;
    }

    /* Form field focus — rose */
    .form-field input:focus,
    .form-field select:focus {
      border-color: var(--water-teal);
      box-shadow: 0 0 0 3px rgba(181, 54, 107, 0.10);
    }
    .last\\:mb-0:last-child{
  margin-bottom: 0px;
}
    .last\\:border-0:last-child{
  border-width: 0px;
}
    .odd\\:bg-white:nth-child(odd){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
    .even\\:bg-slate-50\\/50:nth-child(even){
  background-color: rgb(248 250 252 / 0.5);
}
    .hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
    .hover\\:border-\\[\\#0e8f6f\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(14 143 111 / var(--tw-border-opacity, 1));
}
    .hover\\:border-\\[\\#9c2942\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(156 41 66 / var(--tw-border-opacity, 1));
}
    .hover\\:bg-\\[\\#12A57C\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(18 165 124 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-\\[\\#1e1575\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 21 117 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-\\[\\#1e456c\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 69 108 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-\\[\\#6D1535\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(109 21 53 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-\\[\\#7a1830\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(122 24 48 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-\\[\\#9c2942\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 41 66 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-\\[\\#FDF0F4\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 240 244 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-\\[\\#fbeef1\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 238 241 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-blue-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-brand-teal:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 41 66 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-cream:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 245 246 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-gray-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-gray-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-green-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-indigo-50\\/40:hover{
  background-color: rgb(238 242 255 / 0.4);
}
    .hover\\:bg-indigo-50\\/50:hover{
  background-color: rgb(238 242 255 / 0.5);
}
    .hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-page-bg:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 241 242 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-purple-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-teal-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
    .hover\\:bg-yellow-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
    .hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
    .hover\\:from-purple-700:hover{
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
    .hover\\:to-indigo-700:hover{
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}
    .hover\\:text-\\[\\#300a14\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(48 10 20 / var(--tw-text-opacity, 1));
}
    .hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
    .hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
    .hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
    .hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
    .hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
    .hover\\:text-teal-900:hover{
  --tw-text-opacity: 1;
  color: rgb(19 78 74 / var(--tw-text-opacity, 1));
}
    .hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
    .hover\\:underline:hover{
  text-decoration-line: underline;
}
    .hover\\:opacity-80:hover{
  opacity: 0.8;
}
    .hover\\:opacity-90:hover{
  opacity: 0.9;
}
    .hover\\:opacity-95:hover{
  opacity: 0.95;
}
    .focus\\:border-\\[\\#9c2942\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(156 41 66 / var(--tw-border-opacity, 1));
}
    .focus\\:border-\\[\\#F97316\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
    .focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
    .focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
    .focus\\:ring:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
    .focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
    .focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
    .focus\\:ring-\\[\\#251e8a\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(37 30 138 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-\\[\\#4a0e1e\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 14 30 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-blue-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-gray-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-gray-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-green-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-indigo-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-orange-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 186 116 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-red-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-teal-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-yellow-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 224 71 / var(--tw-ring-opacity, 1));
}
    .focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
    .focus\\:ring-offset-gray-600:focus{
  --tw-ring-offset-color: #4b5563;
}
    .disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
    .disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
    @media (min-width: 640px){

  .sm\\:right-4{
    right: 1rem;
  }

  .sm\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-\\[15vh\\]{
    height: 15vh;
  }

  .sm\\:h-\\[64px\\]{
    height: 64px;
  }

  .sm\\:h-\\[80px\\]{
    height: 80px;
  }

  .sm\\:max-h-\\[85vh\\]{
    max-height: 85vh;
  }

  .sm\\:max-h-\\[90vh\\]{
    max-height: 90vh;
  }

  .sm\\:w-1\\/2{
    width: 50%;
  }

  .sm\\:w-24{
    width: 6rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-\\[40vw\\]{
    width: 40vw;
  }

  .sm\\:w-\\[50vw\\]{
    width: 50vw;
  }

  .sm\\:w-\\[64px\\]{
    width: 64px;
  }

  .sm\\:w-\\[80\\%\\]{
    width: 80%;
  }

  .sm\\:w-\\[80vw\\]{
    width: 80vw;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:max-w-\\[80\\%\\]{
    max-width: 80%;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:p-0{
    padding: 0px;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-7{
    padding: 1.75rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .sm\\:text-\\[40px\\]{
    font-size: 40px;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
    @media (min-width: 768px){

  .md\\:ml-12{
    margin-left: 3rem;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:h-\\[100px\\]{
    height: 100px;
  }

  .md\\:h-\\[78px\\]{
    height: 78px;
  }

  .md\\:w-\\[50vw\\]{
    width: 50vw;
  }

  .md\\:w-\\[70\\%\\]{
    width: 70%;
  }

  .md\\:w-\\[78px\\]{
    width: 78px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:text-\\[15\\.5px\\]{
    font-size: 15.5px;
  }

  .md\\:text-\\[17px\\]{
    font-size: 17px;
  }

  .md\\:text-\\[21px\\]{
    font-size: 21px;
  }

  .md\\:text-\\[56px\\]{
    font-size: 56px;
  }
}
    @media (min-width: 1024px){

  .lg\\:h-\\[15vh\\]{
    height: 15vh;
  }

  .lg\\:-translate-y-12{
    --tw-translate-y: -3rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-\\[280px_1fr\\]{
    grid-template-columns: 280px 1fr;
  }

  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-\\[12px\\]{
    font-size: 12px;
  }
}
    @media (min-width: 1280px){

  .xl\\:text-\\[15px\\]{
    font-size: 15px;
  }
}
    @media (prefers-color-scheme: dark){

  .dark\\:bg-gray-700{
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }

  .dark\\:focus\\:ring-gray-500:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
  }

  .dark\\:focus\\:ring-offset-gray-700:focus{
    --tw-ring-offset-color: #374151;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAG/C,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd,kEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,WAAc;EAAd,YAAc;EAAd,WAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,YAAc;EAAd,8BAAc;EAAd,oBAAc;EAAd,gDAAc;EAAd,mCAAc;EAAd;AAAc;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+GAAmB;EAAnB,sIAAmB;EAAnB;AAAmB;AAAnB;EAAA,qHAAmB;EAAnB,sIAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAOnB;;mFAEmF;AACnF;EACE,0BAA0B;AAC5B;;AAEA,+EAA+E;AAC/E;EACE,wEAAwE;EACxE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;EACtC,oBAAoB;AACtB;AACA;EACE,KAAK,mBAAmB,EAAE,UAAU,EAAE;EACtC,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,6CAA6C;EAC7C,WAAW;AACb;AACA;EACE,qDAAqD;EACrD,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA,uCAAuC;AACvC;MACM,uDAAuD;MACvD,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,uBAAuB;MACvB,yBAAyB;MACzB,sBAAsB;MACtB,2BAA2B;MAC3B,qBAAqB;MACrB,eAAe;MACf,oBAAoB;MACpB,oBAAoB;MACpB,mBAAmB;MACnB,qBAAqB;MACrB,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,sBAAsB;MACtB,sBAAsB;MACtB,wBAAwB;;MAExB,6BAA6B;MAC7B,qBAAqB;MACrB,oBAAoB;MACpB,qBAAqB;MACrB,qBAAqB;MACrB,qBAAqB;MACrB,eAAe;MACf,mBAAmB;MACnB,qBAAqB;MACrB,qBAAqB;MACrB,oBAAoB;;MAEpB,cAAc;MACd,iBAAiB;MACjB,iBAAiB;MACjB,6EAA6E;MAC7E,+CAA+C;MAC/C,kBAAkB;IACpB;;IAEA;;;MAGE,sBAAsB;MACtB,SAAS;MACT,UAAU;IACZ;;IAEA;;MAEE,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE,2CAA2C;MAC3C,uBAAuB;MACvB,eAAe;MACf,mCAAmC;MACnC;;;sEAGgE;IAClE;;IAEA,0DAA0D;IAC1D;MACE,eAAe;MACf,QAAQ;MACR,UAAU;MACV,oBAAoB;MACpB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,OAAO;MACP,YAAY;MACZ,WAAW;MACX,YAAY;IACd;;IAEA;MACE,6CAA6C;MAC7C,WAAW;IACb;;IAEA;MACE,qDAAqD;MACrD,YAAY;IACd;;IAEA;MACE;QACE,wBAAwB;MAC1B;;MAEA;QACE,2BAA2B;MAC7B;IACF;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;MAClB,2CAA2C;MAC3C,yCAAyC;IAC3C;;IAEA;MACE;QACE,qBAAqB;QACrB,WAAW;MACb;;MAEA;QACE,qBAAqB;QACrB,UAAU;MACZ;IACF;;IAEA;;;MAGE,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,cAAc;MACd,qBAAqB;IACvB;;IAEA;MACE,oBAAoB;MACpB,eAAe;MACf,YAAY;MACZ,gBAAgB;IAClB;;IAEA;;;MAGE,oBAAoB;MACpB,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,2CAA2C;IAC7C;;IAEA,4CAA4C;IAC5C;MACE,aAAa;MACb,aAAa;MACb,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,sBAAsB;IACxB;;IAEA,4CAA4C;IAC5C;MACE,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,kBAAkB;MAClB,iBAAiB;MACjB,uGAAuG;MACvG,oCAAoC;MACpC,gBAAgB;MAChB,cAAc;MACd,6CAA6C;IAC/C;;IAEA,+CAA+C;IAC/C;MACE,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR;;;uFAGiF;MACjF,gDAAgD;MAChD,YAAY;MACZ,UAAU;IACZ;;IAEA,kDAAkD;IAClD;MACE,YAAY;MACZ,kBAAkB;MAClB,YAAY;MACZ,QAAQ;MACR,2BAA2B;MAC3B,eAAe;MACf,6BAA6B;MAC7B,UAAU;MACV,oBAAoB;MACpB,4CAA4C;IAC9C;;IAEA;MACE,WAAW,yCAAyC,EAAE,aAAa,EAAE;MACrE,MAAM,wCAAwC,EAAE,aAAa,EAAE;IACjE;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,0CAA0C;MAC1C,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,yCAAyC;MACzC,cAAc;MACd,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;IACV;;IAEA;MACE,eAAe;MACf,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,aAAa;IACf;;IAEA;MACE,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,gCAAgC;MAChC,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,eAAe;MACf,cAAc;MACd,oBAAoB;MACpB,gBAAgB;MAChB,2CAA2C;MAC3C,+CAA+C;IACjD;;IAEA;MACE,cAAc;MACd,iBAAiB;MACjB,wBAAwB;MACxB,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;MACzB,eAAe;MACf,gCAAgC;IAClC;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,yBAAyB;MACzB,eAAe;MACf,yBAAyB;MACzB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,UAAU;MACV,WAAW;MACX,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,gBAAgB;MAChB,oBAAoB;MACpB,yBAAyB;MACzB,yBAAyB;MACzB,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,uBAAuB;MACvB,WAAW;MACX,gBAAgB;MAChB,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,wBAAwB;MACxB,eAAe;IACjB;;IAEA;MACE,uBAAuB;MACvB,WAAW;MACX,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,oBAAoB;MACpB,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,8CAA8C;IAChD;;IAEA;MACE,qCAAqC;MACrC,WAAW;MACX,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,oBAAoB;MACpB,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,6CAA6C;MAC7C,0BAA0B;IAC5B;;IAEA,iDAAiD;IACjD;MACE,kBAAkB;MAClB,SAAO;MACP,gBAAgB;MAChB,aAAa;MACb,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,gIAAgI;MAChI,oBAAoB;IACtB;;IAEA,2CAA2C;IAC3C;MACE,SAAO;MACP,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,kBAAkB;MAClB,SAAS;MACT,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,kEAAkE;MAClE,6BAA6B;MAC7B,qBAAqB;MACrB,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,mBAAmB;IACrB;;IAEA;MACE,yBAAyB;MACzB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,sBAAsB;MACtB,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,SAAS;IACX;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,cAAc;MACd,UAAU;MACV,aAAa;MACb,uBAAuB;MACvB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;MACnB,4BAA4B;MAC5B,uBAAuB;MACvB,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,mBAAmB;MACnB,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,eAAe;MACf,sCAAsC;IACxC;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,iCAAiC;MACjC,yBAAyB;MACzB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,wBAAwB;MACxB,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,wBAAwB;IAC1B;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,4BAA4B;MAC5B,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,WAAW;MACX,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;IACzB;;IAEA;MACE,YAAY;MACZ,UAAU;MACV,YAAY;IACd;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,yBAAyB;MACzB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,aAAa;MACb,wBAAwB;MACxB,eAAe;MACf,mCAAmC;MACnC,gBAAgB;MAChB,kBAAkB;MAClB,UAAU;IACZ;;IAEA,yCAAyC;IACzC;MACE,SAAO;MACP,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,kBAAkB;MAClB,UAAU;MACV,gBAAgB;MAChB,cAAc;MACd,WAAW;IACb;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,gBAAgB;MAChB,+BAA+B;MAC/B,4BAA4B;MAC5B,kBAAkB;MAClB,WAAW;MACX,gBAAgB;MAChB,cAAc;MACd,uCAAuC;MACvC,kBAAkB;IACpB;;IAEA;MACE;QACE,sBAAsB;QACtB,SAAS;QACT,kBAAkB;MACpB;;MAEA;QACE,WAAW;QACX,gBAAgB;MAClB;IACF;;IAEA;MACE;QACE,0BAA0B;MAC5B;IACF;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,wBAAwB;MACxB,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,0BAA0B;MAC1B,oBAAoB;MACpB,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,SAAO;MACP,iBAAiB;MACjB,oBAAoB;MACpB,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,yEAAyE;MACzE,WAAW;MACX,6CAA6C;IAC/C;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,cAAc;IAChB;;IAEA;;MAEE,WAAW;MACX,kBAAkB;MAClB,iCAAiC;MACjC,+BAA+B;MAC/B,eAAe;MACf,aAAa;MACb,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;;MAEE,+BAA+B;IACjC;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,eAAe;MACf,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,aAAa;MACb,yEAAyE;MACzE,WAAW;MACX,gBAAgB;MAChB,eAAe;MACf,+BAA+B;MAC/B,8CAA8C;MAC9C,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,aAAa;MACb,0BAA0B;MAC1B,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,+BAA+B;MAC/B,iCAAiC;IACnC;;IAEA;MACE,kBAAkB;MAClB,wBAAwB;MACxB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA,wCAAwC;IACxC;MACE,aAAa;MACb,aAAa;MACb,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,SAAO;MACP,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;IACf;;IAEA;MACE,uBAAuB;MACvB,uEAAuE;MACvE,qCAAqC;MACrC,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,cAAc;MACd,kBAAkB;MAClB,UAAU;MACV,6CAA6C;IAC/C;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,kBAAkB;MAClB,+BAA+B;MAC/B,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,iCAAiC;MACjC,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,gCAAgC;IAClC;;IAEA;MACE,yEAAyE;MACzE,WAAW;MACX,yBAAyB;MACzB,6CAA6C;IAC/C;;IAEA;MACE,SAAO;IACT;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,QAAQ;MACR,uBAAuB;MACvB,gBAAgB;MAChB,kBAAkB;MAClB,mCAAmC;MACnC,mBAAmB;MACnB,2CAA2C;IAC7C;;IAEA;MACE,YAAY;MACZ,cAAc;MACd,wBAAwB;MACxB,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,eAAe;MACf,wBAAwB;MACxB,gBAAgB;MAChB,qBAAqB;MACrB,kBAAkB;IACpB;;IAEA;MACE,0EAA0E;MAC1E,WAAW;MACX,gBAAgB;MAChB,kBAAkB;MAClB,+BAA+B;MAC/B,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,uBAAuB;MACvB,8CAA8C;IAChD;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,kBAAkB;MAClB,+BAA+B;MAC/B,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,mBAAmB;MACnB,2BAA2B;MAC3B,gCAAgC;MAChC,eAAe;MACf,sCAAsC;IACxC;;IAEA;MACE,cAAc;MACd,mBAAmB;MACnB,qBAAqB;IACvB;;IAEA;MACE,SAAO;MACP,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,aAAa;IACf;;IAEA;MACE,iBAAiB;MACjB,UAAU;MACV,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,SAAO;MACP,sBAAsB;MACtB,aAAa;IACf;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,aAAa;IACf;;IAEA,2CAA2C;IAC3C;MACE,kBAAkB;MAClB,sCAAsC;MACtC,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,sBAAsB;MACtB,iBAAiB;IACnB;;IAEA;MACE,iCAAiC;MACjC,+BAA+B;MAC/B,iBAAiB;MACjB,eAAe;MACf,sBAAsB;MACtB,cAAc;MACd,iBAAiB;IACnB;;IAEA;MACE,SAAO;MACP,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,+EAA+E;MAC/E,uFAAuF;IACzF;;IAEA;MACE,qBAAqB;MACrB,kBAAkB;MAClB,6CAA6C;MAC7C,sBAAsB;MACtB,iBAAiB;IACnB;;IAEA;MACE;QACE,wBAAwB;MAC1B;;MAEA;QACE,4BAA4B;MAC9B;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,SAAO;MACP,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,SAAO;MACP,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,kBAAkB;MAClB,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,oCAAoC;MACpC,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,sBAAsB;MACtB,4BAA4B;IAC9B;;IAEA;MACE,eAAe;MACf,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,4BAA4B;MAC5B,yBAAyB;MACzB,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,eAAe;MACf,gBAAgB;MAChB,eAAe;MACf,kCAAkC;IACpC;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,aAAa;MACb,SAAS;MACT,cAAc;MACd,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,oBAAoB;MACpB,2BAA2B;IAC7B;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,cAAc;MACd,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,uEAAuE;IACzE;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,yBAAyB;MACzB,eAAe;MACf,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,SAAS;MACT,eAAe;MACf,wBAAwB;MACxB,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,+BAA+B;MAC/B,4BAA4B;MAC5B,gBAAgB;MAChB,gBAAgB;MAChB,sBAAsB;MACtB,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,0EAA0E;MAC1E,WAAW;MACX,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,yBAAyB;MACzB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,sCAAsC;MACtC,iBAAiB;IACnB;;IAEA;MACE,wBAAwB;MACxB,gBAAgB;MAChB,UAAU;IACZ;;IAEA;MACE,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR,iCAAiC;MACjC,8BAA8B;MAC9B,iBAAiB;MACjB,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,wBAAwB;MACxB,gBAAgB;MAChB,eAAe;MACf,qCAAqC;MACrC,iBAAiB;MACjB,+BAA+B;MAC/B,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;MACR,mBAAmB;MACnB,0BAA0B;MAC1B,+BAA+B;MAC/B,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;MAClB,+BAA+B;MAC/B,iCAAiC;MACjC,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,gBAAgB;IAClB;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,gCAAgC;MAChC,iCAAiC;MACjC,8BAA8B;IAChC;;IAEA;MACE,sBAAsB;MACtB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,SAAS;IACX;;IAEA;;MAEE,iBAAiB;MACjB,+BAA+B;MAC/B,gBAAgB;MAChB,eAAe;MACf,iCAAiC;MACjC,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,sBAAsB;IACxB;;IAEA;MACE,iCAAiC;MACjC,8BAA8B;MAC9B,gCAAgC;IAClC;;IAEA;MACE,mBAAmB;MACnB,cAAc;MACd,qBAAqB;IACvB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;MACjB,+BAA+B;MAC/B,gBAAgB;MAChB,eAAe;MACf,8BAA8B;MAC9B,WAAW;MACX,6CAA6C;IAC/C;;IAEA;MACE,uBAAuB;MACvB,uBAAuB;MACvB,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,gBAAgB;MAChB,oBAAoB;MACpB,4BAA4B;MAC5B,yBAAyB;IAC3B;;IAEA;MACE,SAAO;MACP,YAAY;MACZ,aAAa;MACb,eAAe;MACf,uBAAuB;IACzB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,yBAAyB;MACzB,eAAe;MACf,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;MACnB,cAAc;MACd,4BAA4B;IAC9B;;IAEA;MACE;QACE,yCAAyC;MAC3C;;MAEA;QACE,0CAA0C;MAC5C;;MAEA;QACE,wCAAwC;MAC1C;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,8BAA8B;MAC9B,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,cAAc;MACd,6CAA6C;IAC/C;;IAEA;MACE,aAAa;MACb,QAAQ;MACR,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,UAAU;MACV,WAAW;MACX,kBAAkB;MAClB,6BAA6B;MAC7B,0CAA0C;IAC5C;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;;MAEE;;;QAGE,YAAY;MACd;;MAEA;QACE,UAAU;MACZ;IACF;;IAEA;;MAEE;;QAEE,6CAA6C;MAC/C;;MAEA;QACE,+CAA+C;MACjD;IACF;;IAEA,+CAA+C;IAC/C;MACE,uBAAuB;MACvB,SAAO;MACP,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,eAAe;MACf,cAAc;MACd,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,qCAAqC;MACrC,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,+BAA+B;MAC/B,kBAAkB;MAClB,WAAW;MACX,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,4BAA4B;IAC9B;;IAEA;MACE,qDAAqD;IACvD;;IAEA;MACE,qDAAqD;IACvD;;IAEA;MACE,qDAAqD;IACvD;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,qCAAqC;MACrC,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,+BAA+B;MAC/B,yBAAyB;MACzB,aAAa;MACb,+BAA+B;MAC/B,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA,oCAAoC;IACpC;MACE,YAAY;MACZ,kBAAkB;MAClB,aAAa;MACb,WAAW;MACX,eAAe;MACf,+BAA+B;MAC/B,oBAAoB;MACpB,UAAU;IACZ;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;MACnB,kBAAkB;MAClB,sCAAsC;MACtC,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,kCAAkC;MAClC,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,kBAAkB;MAClB,iCAAiC;MACjC,+BAA+B;MAC/B,mBAAmB;MACnB,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,yBAAyB;IAC3B;;IAEA;MACE,gBAAgB;MAChB,MAAM;MACN,4DAA4D;MAC5D,UAAU;MACV,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,0CAA0C;MAC1C,yBAAyB;MACzB,oBAAoB;MACpB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,sCAAsC;MACtC,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,wBAAwB;MACxB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;MACf,WAAW;MACX,qBAAqB;IACvB;;IAEA;MACE,qDAAqD;IACvD;;IAEA;;MAEE,qDAAqD;IACvD;;IAEA;MACE,qDAAqD;IACvD;;IAEA;MACE,iCAAiC;MACjC,+BAA+B;MAC/B,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,iCAAiC;MACjC,8BAA8B;MAC9B,aAAa;MACb,mBAAmB;MACnB,uBAAuB;IACzB;;IAEA,oEAAoE;IACpE;MACE,eAAe;MACf,yBAAiB;cAAjB,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,eAAe;MACf,wBAAwB;IAC1B;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,SAAS;MACT,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;IAClB;;IAEA,uDAAuD;IACvD;MACE,aAAa;MACb,gCAAgC;MAChC,SAAS;MACT,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA,wDAAwD;IACxD;MACE,mBAAmB;MACnB,WAAW;MACX,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,YAAY;MACZ,eAAe;MACf,mBAAmB;MACnB,2BAA2B;IAC7B;;IAEA;MACE,mBAAmB;IACrB;;IAEA,qDAAqD;IACrD;MACE,qBAAqB;MACrB,mBAAmB;MACnB,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,0CAA0C;MAC1C,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;IACjB;;IAEA,0BAA0B;IAC1B;MACE,mCAAmC;MACnC,cAAc;IAChB;;IAEA,0DAA0D;IAC1D;MACE,gBAAgB;MAChB,4BAA4B;MAC5B,yBAAyB;MACzB,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,eAAe;MACf,gBAAgB;MAChB,eAAe;MACf,kCAAkC;MAClC,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,kBAAkB;MAClB,UAAU;MACV,UAAU;MACV,6BAA6B;MAC7B,WAAW;MACX,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;MACpB,iBAAiB;MACjB,oBAAoB;MACpB,yBAAyB;IAC3B;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,UAAU;IACZ;;IAEA,qCAAqC;IACrC;MACE,aAAa;MACb,eAAe;MACf,QAAQ;MACR,iCAAiC;MACjC,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,+BAA+B;MAC/B,4BAA4B;MAC5B,gBAAgB;MAChB,WAAW;MACX,gBAAgB;MAChB,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,0BAA0B;MAC1B,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,sBAAsB;MACtB,eAAe;MACf,UAAU;IACZ;;IAEA;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,iCAAiC;MACjC,yBAAyB;MACzB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,cAAc;MACd,mBAAmB;IACrB;;IAEA;MACE,sBAAsB;MACtB,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,qBAAqB;MACrB,mBAAmB;MACnB,0BAA0B;MAC1B,uCAAuC;MACvC,+BAA+B;MAC/B,kBAAkB;MAClB,gBAAgB;MAChB,8BAA8B;MAC9B,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,SAAS;IACX;;IAEA;MACE,SAAO;MACP,aAAa;MACb,+BAA+B;MAC/B,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,0BAA0B;MAC1B,kBAAkB;MAClB,iCAAiC;IACnC;;IAEA;MACE,8BAA8B;MAC9B,WAAW;MACX,6CAA6C;IAC/C;;IAEA;MACE,kBAAkB;MAClB,sCAAsC;IACxC;;IAEA;MACE,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,yBAAyB;MACzB,oBAAoB;MACpB,wBAAwB;MACxB,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;MACf,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,0BAA0B;MAC1B,+BAA+B;MAC/B,aAAa;MACb,wBAAwB;MACxB,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,SAAS;MACT,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,iBAAiB;MACjB,yBAAyB;MACzB,wBAAwB;MACxB,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;IAChB;;IAEA,mDAAmD;IACnD;MACE,eAAe;MACf,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;MACzB,wBAAwB;MACxB,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,QAAQ;IACV;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR,iCAAiC;MACjC,wBAAwB;MACxB,mCAAmC;MACnC,iBAAiB;MACjB,gBAAgB;MAChB,yBAAyB;MACzB,qBAAqB;MACrB,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;MAC1B,wCAAwC;MACxC,+BAA+B;MAC/B,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,eAAe;MACf,wBAAwB;MACxB,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,yBAAiB;cAAjB,iBAAiB;IACnB;;IAEA;MACE,8BAA8B;MAC9B,eAAe;IACjB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,oCAAoC;MACpC,+BAA+B;MAC/B,+BAA+B;MAC/B,kBAAkB;MAClB,eAAe;MACf,sBAAsB;MACtB,aAAa;MACb,gBAAgB;IAClB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,SAAS;MACT,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;MAC1B,+BAA+B;MAC/B,kCAAkC;MAClC,+BAA+B;MAC/B,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,eAAe;MACf,yBAAyB;MACzB,qBAAqB;MACrB,wBAAwB;MACxB,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA,8DAA8D;IAC9D;MACE,0BAA0B;MAC1B,iCAAiC;MACjC,4BAA4B;MAC5B,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,iCAAiC;MACjC,+BAA+B;MAC/B,kBAAkB;MAClB,iBAAiB;MACjB,oBAAoB;MACpB,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,0BAA0B;IAC5B;;IAEA;MACE,mBAAmB;MACnB,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,sBAAsB;MACtB,kBAAkB;MAClB,yBAAyB;MACzB,qBAAqB;IACvB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,UAAU;MACV,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,uBAAuB;MACvB,iBAAiB;MACjB,uBAAuB;MACvB,wCAAwC;MACxC,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,UAAU;MACV,SAAS;MACT,UAAU;MACV,WAAW;MACX,kBAAkB;MAClB,6BAA6B;IAC/B;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR,iBAAiB;MACjB,gBAAgB;MAChB,yBAAyB;MACzB,qBAAqB;MACrB,iBAAiB;MACjB,oBAAoB;IACtB;;IAEA;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,iCAAiC;MACjC,wBAAwB;IAC1B;;IAEA;MACE,mBAAmB;MACnB,8BAA8B;IAChC;;IAEA;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,eAAe;MACf,SAAS;MACT,gBAAgB;IAClB;;IAEA;MACE,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,0BAA0B;MAC1B,qCAAqC;MACrC,wBAAwB;IAC1B;;IAEA;MACE,0BAA0B;MAC1B,iCAAiC;MACjC,uBAAuB;IACzB;;IAEA;MACE,6BAA6B;MAC7B,WAAW;IACb;;IAEA;MACE,8BAA8B;MAC9B,WAAW;IACb;;IAEA;MACE,gBAAgB;MAChB,2BAA2B;MAC3B,cAAc;IAChB;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,mCAAmC;MACnC,aAAa;MACb,yBAAyB;IAC3B;;IAEA;MACE,0BAA0B;MAC1B,kBAAkB;MAClB,gBAAgB;MAChB,kBAAkB;MAClB,+BAA+B;MAC/B,iCAAiC;IACnC;;IAEA;MACE,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,cAAc;MACd,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,QAAQ;MACR,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,wBAAwB;MACxB,gBAAgB;IAClB;;IAEA;;MAEE,cAAc;IAChB;;IAEA;MACE,WAAW;MACX,iBAAiB;MACjB,iCAAiC;MACjC,+BAA+B;MAC/B,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,aAAa;MACb,gBAAgB;IAClB;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,WAAW;MACX,aAAa;MACb,8BAA8B;MAC9B,WAAW;MACX,gBAAgB;MAChB,+BAA+B;MAC/B,8CAA8C;IAChD;;IAEA,+CAA+C;IAC/C;MACE,gBAAgB;MAChB,+BAA+B;MAC/B,yBAAyB;MACzB,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,kBAAkB;MAClB,8BAA8B;MAC9B,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,wBAAwB;MACxB,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,cAAc;MACd,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,SAAS;IACX;;IAEA;MACE,mBAAmB;MACnB,WAAW;MACX,gBAAgB;MAChB,aAAa;MACb,+BAA+B;IACjC;;IAEA;MACE,0EAA0E;MAC1E,WAAW;MACX,gBAAgB;MAChB,aAAa;MACb,+BAA+B;MAC/B,6CAA6C;IAC/C;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,UAAU;IACZ;;IAEA,oDAAoD;IACpD;MACE,SAAO;MACP,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,kBAAkB;MAClB,kBAAkB;MAClB,UAAU;MACV,aAAa;IACf;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,iCAAiC;MACjC,yBAAyB;MACzB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,sBAAsB;MACtB,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA,oCAAoC;IACpC;MACE,eAAe;MACf,YAAY;MACZ,SAAS;MACT,4CAA4C;MAC5C,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,gBAAgB;MAChB,0CAA0C;MAC1C,YAAY;MACZ,UAAU;MACV,oBAAoB;MACpB,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,UAAU;MACV,yCAAyC;IAC3C;;IAEA;MACE,cAAc;IAChB;;IAEA,SAAS;IACT;MACE,gBAAgB;IAClB;;IAEA;MACE,UAAU;MACV,WAAW;IACb;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,wEAAwE;MACxE,kBAAkB;IACpB;;IAEA,8DAA8D;IAC9D;MACE,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR,wEAAwE;MACxE,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;MACzB,iBAAiB;MACjB,oBAAoB;IACtB;;IAEA,qCAAqC;IACrC;MACE,KAAK,oCAAoC,EAAE,YAAY,EAAE;MACzD,MAAM,mCAAmC,EAAE,UAAU,EAAE;MACvD,OAAO,oCAAoC,EAAE,YAAY,EAAE;IAC7D;;IAEA;MACE,6CAA6C;MAC7C,uEAAuE;MACvE,wBAAwB;IAC1B;;IAEA,gDAAgD;IAChD;;;MAGE,+CAA+C;MAC/C,kBAAkB;IACpB;;IAEA,0CAA0C;IAC1C;MACE,iCAAiC;MACjC,4BAA4B;MAC5B,kBAAkB;IACpB;IACA;MACE,WAAW;MACX,kBAAkB;MAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;MACzB,WAAW;MACX,qFAAqF;MACrF,oDAAoD;MACpD,UAAU;IACZ;;IAEA,uCAAuC;IACvC;MACE,2FAA2F;MAC3F,wCAAwC;MACxC,uBAAuB;IACzB;;IAEA,mCAAmC;IACnC;MACE,wCAAwC;IAC1C;IACA;MACE,6BAA6B;IAC/B;;IAEA,6BAA6B;IAC7B;MACE,0CAA0C;IAC5C;;IAEA,sCAAsC;IACtC;MACE,yEAAyE;MACzE,WAAW;MACX,yBAAyB;MACzB,8CAA8C;IAChD;;IAEA,oCAAoC;IACpC;MACE,wEAAwE;MACxE,WAAW;MACX,gBAAgB;MAChB,aAAa;MACb,+BAA+B;MAC/B,8CAA8C;IAChD;;IAEA,uBAAuB;IACvB;MACE,wEAAwE;MACxE,8CAA8C;IAChD;;IAEA,uBAAuB;IACvB;;MAEE,+BAA+B;MAC/B,mBAAmB;IACrB;;IAEA,uBAAuB;IACvB;MACE,6BAA6B;IAC/B;;IAEA,sBAAsB;IACtB;MACE,wCAAwC;MACxC,2BAA2B;IAC7B;;IAEA,2BAA2B;IAC3B;MACE,+BAA+B;MAC/B,wBAAwB;IAC1B;IACA;MACE,6BAA6B;MAC7B,WAAW;IACb;;IAEA,2BAA2B;IAC3B;MACE,wEAAwE;MACxE,8CAA8C;IAChD;;IAEA,qCAAqC;IACrC;MACE,mBAAmB;MACnB,iCAAiC;IACnC;;IAEA,yBAAyB;IACzB;MACE,mBAAmB;IACrB;;IAEA,wCAAwC;IACxC;MACE,2BAA2B;MAC3B,wBAAwB;MACxB,mCAAmC;IACrC;;IAEA,wBAAwB;IACxB;MACE,yEAAyE;IAC3E;;IAEA,qBAAqB;IACrB;MACE,yEAAyE;MACzE,6CAA6C;IAC/C;;IAEA,mBAAmB;IACnB;MACE,wEAAwE;IAC1E;;IAEA,4CAA4C;IAC5C;MACE,WAAW,uCAAuC,EAAE;MACpD,MAAM,wCAAwC,EAAE;MAChD,MAAM,yCAAyC,EAAE;IACnD;IACA;MACE,6CAA6C;MAC7C,qBAAqB;IACvB;;IAEA,mBAAmB;IACnB;MACE,+BAA+B;IACjC;;IAEA,yBAAyB;IACzB;MACE,2BAA2B;MAC3B,wBAAwB;IAC1B;;IAEA,oCAAoC;IACpC;MACE,qDAAqD;IACvD;;IAEA,cAAc;IACd;MACE,2BAA2B;MAC3B,uBAAuB;IACzB;;IAEA,yBAAyB;IACzB;MACE,wBAAwB;MACxB,mBAAmB;MACnB,qCAAqC;IACvC;IACA;MACE,WAAW;MACX,6BAA6B;MAC7B,+BAA+B;IACjC;;IAEA,YAAY;IACZ;MACE,6DAA6D;MAC7D,qCAAqC;IACvC;;IAEA,yBAAyB;IACzB;MACE,+BAA+B;MAC/B,mBAAmB;IACrB;;IAEA,4BAA4B;IAC5B;;MAEE,+BAA+B;MAC/B,8CAA8C;IAChD;IA3nFJ;EAAA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,sBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,sBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,kBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,4DA4nFA;EA5nFA,oEA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA,sBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,sBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,sBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,8BA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,2GA4nFA;EA5nFA,yGA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,2GA4nFA;EA5nFA,yGA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,2GA4nFA;EA5nFA,yGA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA,oBA4nFA;EA5nFA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;EAAA;AA4nFA;IA5nFA;;EAAA;IAAA;EA4nFA;;EA5nFA;IAAA,oBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA,kBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,oBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,kBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,mBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,iBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,kBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA,eA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,mBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,mBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,kBA4nFA;IA5nFA;EA4nFA;AAAA;IA5nFA;;EAAA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA,kBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,oBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA;EA4nFA;AAAA;IA5nFA;;EAAA;IAAA;EA4nFA;;EA5nFA;IAAA,uBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA;EA4nFA;;EA5nFA;IAAA,mBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA;EA4nFA;AAAA;IA5nFA;;EAAA;IAAA;EA4nFA;AAAA;IA5nFA;;EAAA;IAAA,kBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA,oBA4nFA;IA5nFA;EA4nFA;;EA5nFA;IAAA;EA4nFA;AAAA","sourcesContent":["/* ===== Women-Empowerment Google Fonts ===== */\n@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800;900&family=Inter:wght@400;500;600;700;800&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  html, body {\n    @apply m-0 p-0 w-full h-full font-body bg-page-bg text-gray-800 antialiased;\n  }\n}\n/* SweetAlert2 defaults to z-index 1060, but the complaint modals use z-[9999].\n   Without this, confirm dialogs (e.g. \"Send BTR for Admin Approval?\") open\n   behind the modal and can never be clicked, so BTR resubmission silently fails. */\n.swal2-container {\n  z-index: 100000 !important;\n}\n\n/* Override default SweetAlert2 confirm (OK) button color with brand gradient */\n.swal2-confirm.swal2-styled {\n  background-image: linear-gradient(to right, #45B07B, #12A57C) !important;\n  background-color: transparent !important;\n  border: none !important;\n}\n\n.water-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n.ripple-dot {\n  position: absolute;\n  border-radius: 50%;\n  border: 1px solid rgba(156, 41, 66, 0.15);\n  animation: ripple 8s infinite ease-out;\n  pointer-events: none;\n}\n@keyframes ripple {\n  0% { transform: scale(0); opacity: 1; }\n  100% { transform: scale(3); opacity: 0; }\n}\n.wave-back, .wave-front {\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  width: 200%;\n  height: auto;\n}\n.wave-back {\n  animation: bloomDriftSlow 34s linear infinite;\n  opacity: .5;\n}\n.wave-front {\n  animation: bloomDriftSlow 20s linear infinite reverse;\n  opacity: .75;\n  z-index: 1;\n}\n\n@keyframes bloomDriftSlow {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n/* Appended styles from NCW Prototype */\n:root {\n      /* ===== NCW — \"Shakti\" Women Empowerment Theme ===== */\n      --saffron: #D4A017;\n      --saffron-2: #FEF3D0;\n      --cream: #FDF4F7;\n      --green-accent: #C96A8A;\n      --green-accent-2: #FCE8EF;\n      --brand-green: #9C2942;\n      --brand-green-dark: #7A1A32;\n      --brand-teal: #8B1A4A;\n      --navy: #5C0F28;\n      --navy-dark: #3D0819;\n      --text-dark: #2D0F1A;\n      --text-mid: #6B3047;\n      --text-muted: #A0617A;\n      --border: #F0CDD8;\n      --surface: #ffffff;\n      --page-bg: #FDF0F4;\n      --orange-warn: #C1671F;\n      --status-open: #D98A20;\n      --status-closed: #2D9A6B;\n\n      /* Shakti rose-plum palette */\n      --water-deep: #5C0F28;\n      --water-mid: #8B1A4A;\n      --water-teal: #B5366B;\n      --water-cyan: #E8A0B8;\n      --water-foam: #FDF0F4;\n      --gold: #D4A017;\n      --blush-bg: #FCE8EF;\n      --rose-light: #FDF0F4;\n      --petal-pink: #F5C6D8;\n      --deep-rose: #6D1535;\n\n      --radius: 14px;\n      --radius-sm: 10px;\n      --radius-lg: 20px;\n      --shadow: 0 2px 14px rgba(92, 15, 40, 0.08), 0 1px 4px rgba(92, 15, 40, 0.06);\n      --shadow-md: 0 10px 32px rgba(92, 15, 40, 0.15);\n      --sidebar-w: 250px;\n    }\n\n    *,\n    *::before,\n    *::after {\n      box-sizing: border-box;\n      margin: 0;\n      padding: 0;\n    }\n\n    html,\n    body {\n      height: 100%;\n      overflow: hidden;\n    }\n\n    body {\n      font-family: 'Inter', system-ui, sans-serif;\n      color: var(--text-dark);\n      font-size: 14px;\n      -webkit-font-smoothing: antialiased;\n      background:\n        radial-gradient(1100px 620px at 8% -10%, #F5C6D8 0%, rgba(245, 198, 216, 0) 60%),\n        radial-gradient(900px 560px at 105% 8%, #EDB8CE 0%, rgba(237, 184, 206, 0) 55%),\n        linear-gradient(180deg, #FDF4F7 0%, #FAEEf2 45%, #F7E4EC 100%);\n    }\n\n    /* ============ SITE-WIDE \"SHAKTI\" BACKDROP ============ */\n    .water-backdrop {\n      position: fixed;\n      inset: 0;\n      z-index: 0;\n      pointer-events: none;\n      overflow: hidden;\n    }\n\n    .water-backdrop svg {\n      position: absolute;\n      left: 0;\n      bottom: -2px;\n      width: 200%;\n      height: auto;\n    }\n\n    .water-backdrop .wave-back {\n      animation: bloomDriftSlow 34s linear infinite;\n      opacity: .5;\n    }\n\n    .water-backdrop .wave-front {\n      animation: bloomDriftSlow 20s linear infinite reverse;\n      opacity: .75;\n    }\n\n    @keyframes bloomDriftSlow {\n      from {\n        transform: translateX(0);\n      }\n\n      to {\n        transform: translateX(-50%);\n      }\n    }\n\n    .water-backdrop .ripple-dot {\n      position: absolute;\n      border-radius: 50%;\n      border: 1.5px solid rgba(156, 41, 66, 0.16);\n      animation: glowPulse 6s ease-out infinite;\n    }\n\n    @keyframes glowPulse {\n      0% {\n        transform: scale(0.2);\n        opacity: .6;\n      }\n\n      100% {\n        transform: scale(2.2);\n        opacity: 0;\n      }\n    }\n\n    #screen-landing,\n    #screen-login,\n    #app-shell {\n      position: relative;\n      z-index: 1;\n    }\n\n    a {\n      color: inherit;\n      text-decoration: none;\n    }\n\n    button {\n      font-family: inherit;\n      cursor: pointer;\n      border: none;\n      background: none;\n    }\n\n    input,\n    select,\n    textarea {\n      font-family: inherit;\n      font-size: 14px;\n    }\n\n    img {\n      max-width: 100%;\n      display: block;\n    }\n\n    .serif {\n      font-family: 'Merriweather', Georgia, serif;\n    }\n\n    /* ============ SCREEN SYSTEM ============ */\n    .screen {\n      display: none;\n      height: 100vh;\n      overflow: hidden;\n    }\n\n    .screen.active {\n      display: flex;\n      flex-direction: column;\n    }\n\n    /* ============ SHARED HEADER ============ */\n    .top-header {\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 14px 34px;\n      min-height: 104px;\n      background: linear-gradient(120deg, var(--water-deep) 0%, var(--water-mid) 46%, var(--water-teal) 100%);\n      border-bottom: 3px solid var(--gold);\n      overflow: hidden;\n      flex-shrink: 0;\n      box-shadow: 0 6px 28px rgba(92, 15, 40, 0.28);\n    }\n\n    /* Lotus/Mandala decorative overlay on header */\n    .top-header::before {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      background-image:\n        radial-gradient(rgba(255,255,255,0.12) 1.5px, transparent 1.5px),\n        radial-gradient(circle at 92% 50%, rgba(212, 160, 23, 0.18) 0%, transparent 50%),\n        radial-gradient(circle at 8% 50%, rgba(212, 160, 23, 0.12) 0%, transparent 40%);\n      background-size: 22px 22px, 100% 100%, 100% 100%;\n      opacity: .85;\n      z-index: 0;\n    }\n\n    /* Decorative petal arcs on right side of header */\n    .top-header::after {\n      content: \"❀\";\n      position: absolute;\n      right: 200px;\n      top: 50%;\n      transform: translateY(-50%);\n      font-size: 80px;\n      color: rgba(255,255,255,0.06);\n      z-index: 0;\n      pointer-events: none;\n      animation: petalSway 8s ease-in-out infinite;\n    }\n\n    @keyframes petalSway {\n      0%, 100% { transform: translateY(-50%) rotate(-5deg); opacity: 0.06; }\n      50% { transform: translateY(-52%) rotate(5deg); opacity: 0.10; }\n    }\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      position: relative;\n      z-index: 2;\n    }\n\n    .header-logo {\n      width: 78px;\n      height: 78px;\n      border-radius: 18px;\n      background: #fff;\n      border: 2px solid rgba(224, 122, 44, 0.35);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      overflow: hidden;\n      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);\n      flex-shrink: 0;\n      padding: 6px;\n    }\n\n    .header-logo img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n\n    .header-title-block {\n      display: flex;\n      flex-direction: column;\n      gap: 1px;\n    }\n\n    .header-title {\n      font-size: 15px;\n      color: var(--navy);\n      letter-spacing: .2px;\n      font-weight: 600;\n      display: none;\n    }\n\n    .header-center {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      text-align: center;\n      z-index: 2;\n    }\n\n    .header-center h1 {\n      font-size: 30px;\n      color: #ffffff;\n      letter-spacing: .3px;\n      font-weight: 900;\n      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);\n      font-family: 'Playfair Display', Georgia, serif;\n    }\n\n    .header-center span {\n      display: block;\n      font-size: 11.5px;\n      color: var(--water-cyan);\n      font-weight: 700;\n      letter-spacing: 1.5px;\n      text-transform: uppercase;\n      margin-top: 2px;\n      font-family: 'Inter', sans-serif;\n    }\n\n    .header-title {\n      color: #fbeef1;\n    }\n\n    .header-right {\n      display: flex;\n      align-items: center;\n      gap: 14px;\n      position: relative;\n      z-index: 2;\n    }\n\n    .bell-btn {\n      width: 38px;\n      height: 38px;\n      border-radius: 50%;\n      background: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--orange-warn);\n      font-size: 16px;\n      box-shadow: var(--shadow);\n      position: relative;\n    }\n\n    .bell-btn .dot {\n      position: absolute;\n      top: 8px;\n      right: 9px;\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background: #e0433a;\n    }\n\n    .profile-chip {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      background: #fff;\n      border-radius: 999px;\n      padding: 6px 14px 6px 6px;\n      box-shadow: var(--shadow);\n      cursor: pointer;\n    }\n\n    .profile-avatar {\n      width: 26px;\n      height: 26px;\n      border-radius: 50%;\n      background: var(--navy);\n      color: #fff;\n      font-weight: 700;\n      font-size: 12px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n    }\n\n    .profile-name {\n      font-weight: 600;\n      color: var(--navy);\n      font-size: 14px;\n    }\n\n    .profile-chip i {\n      color: var(--text-muted);\n      font-size: 11px;\n    }\n\n    .sign-in-btn {\n      background: var(--gold);\n      color: #fff;\n      font-weight: 700;\n      font-size: 14px;\n      padding: 11px 22px;\n      border-radius: 999px;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      box-shadow: 0 4px 14px rgba(201, 150, 47, 0.4);\n    }\n\n    .sign-up-btn {\n      background: rgba(255, 255, 255, 0.14);\n      color: #fff;\n      font-weight: 700;\n      font-size: 14px;\n      padding: 11px 22px;\n      border-radius: 999px;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      border: 1.5px solid rgba(255, 255, 255, 0.55);\n      backdrop-filter: blur(4px);\n    }\n\n    /* ============ WATERMARK BACKDROP ============ */\n    .watermark-wrap {\n      position: relative;\n      flex: 1;\n      overflow: hidden;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .watermark-wrap .wm-bg-tint {\n      position: absolute;\n      inset: 0;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.42) 40%, rgba(255, 255, 255, 0.55) 100%);\n      pointer-events: none;\n    }\n\n    /* ============ LANDING PAGE ============ */\n    #screen-landing .landing-body {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 70px 90px;\n      gap: 40px;\n      position: relative;\n      z-index: 2;\n    }\n\n    .landing-copy {\n      max-width: 620px;\n      position: relative;\n      z-index: 2;\n    }\n\n    .landing-copy h1 {\n      font-size: 56px;\n      line-height: 1.08;\n      font-weight: 900;\n      background: linear-gradient(90deg, var(--brand-teal), var(--navy));\n      -webkit-background-clip: text;\n      background-clip: text;\n      color: transparent;\n      margin-bottom: 16px;\n    }\n\n    .landing-copy h2 {\n      font-size: 21px;\n      font-weight: 800;\n      color: #0e2f4d;\n      margin-bottom: 14px;\n    }\n\n    .landing-copy .eyebrow {\n      color: var(--orange-warn);\n      font-weight: 800;\n      font-size: 17px;\n      margin-bottom: 12px;\n    }\n\n    .landing-copy p {\n      color: var(--text-mid);\n      font-size: 15.5px;\n      line-height: 1.7;\n      margin-bottom: 30px;\n      max-width: 540px;\n    }\n\n    .landing-btn-row {\n      display: flex;\n      gap: 16px;\n    }\n\n    .landing-visual {\n      position: relative;\n      width: 460px;\n      flex-shrink: 0;\n      z-index: 2;\n      display: flex;\n      justify-content: center;\n      padding: 44px 30px 56px;\n    }\n\n    .live-updates-card {\n      background: #fff;\n      border-radius: 22px;\n      box-shadow: var(--shadow-md);\n      padding: 30px 30px 22px;\n      width: 100%;\n      max-width: 400px;\n    }\n\n    .live-updates-card h4 {\n      font-size: 18px;\n      margin-bottom: 20px;\n      color: #0e2f4d;\n      font-weight: 800;\n    }\n\n    .lu-item {\n      display: flex;\n      align-items: center;\n      gap: 14px;\n      padding: 14px 0;\n      border-bottom: 1px solid var(--border);\n    }\n\n    .lu-item:last-child {\n      border-bottom: none;\n    }\n\n    .lu-check {\n      width: 38px;\n      height: 38px;\n      border-radius: 50%;\n      background: var(--green-accent-2);\n      color: var(--brand-green);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n      font-size: 15px;\n    }\n\n    .lu-item .lu-text b {\n      display: block;\n      font-size: 15px;\n      font-weight: 700;\n      color: #0e2f4d;\n      margin-bottom: 2px;\n    }\n\n    .lu-item .lu-text small {\n      color: var(--text-muted);\n      font-size: 12.5px;\n    }\n\n    .lu-item .lu-arrow {\n      margin-left: auto;\n      color: var(--text-muted);\n    }\n\n    .mini-card {\n      position: absolute;\n      background: #fff;\n      border-radius: 14px;\n      box-shadow: var(--shadow-md);\n      padding: 14px 16px;\n    }\n\n    .mini-card.chart-icon {\n      top: 10px;\n      right: 14px;\n      width: 60px;\n      height: 60px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .mini-card.response-time {\n      bottom: 16px;\n      left: 10px;\n      width: 190px;\n    }\n\n    .response-time .rt-top {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 6px;\n    }\n\n    .response-time .rt-top span:first-child {\n      font-size: 12px;\n      color: var(--text-mid);\n      font-weight: 600;\n    }\n\n    .response-time .rt-top span:last-child {\n      font-size: 15px;\n      color: var(--orange-warn);\n      font-weight: 800;\n    }\n\n    .footer-note {\n      text-align: center;\n      padding: 14px;\n      color: var(--text-muted);\n      font-size: 12px;\n      border-top: 1px solid var(--border);\n      background: #fff;\n      position: relative;\n      z-index: 3;\n    }\n\n    /* ============ LOGIN PAGE ============ */\n    #screen-login .login-body {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 40px 20px;\n      position: relative;\n      z-index: 2;\n      max-width: 520px;\n      margin: 0 auto;\n      width: 100%;\n    }\n\n    .login-map {\n      display: none !important;\n    }\n\n    .login-card {\n      background: #fff;\n      border-radius: var(--radius-lg);\n      box-shadow: var(--shadow-md);\n      padding: 40px 52px;\n      width: 100%;\n      max-width: 520px;\n      flex-shrink: 0;\n      border-top: 4px solid var(--water-teal);\n      position: relative;\n    }\n\n    @media (max-width:1100px) {\n      .login-body {\n        flex-direction: column;\n        gap: 24px;\n        padding: 20px 30px;\n      }\n\n      .login-map {\n        width: 100%;\n        max-width: 320px;\n      }\n    }\n\n    @media (max-width:600px) {\n      .slot-grid, .vq-grid {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .login-card h2 {\n      text-align: center;\n      font-size: 22px;\n      color: #0e2f4d;\n      margin-bottom: 6px;\n    }\n\n    .login-card p.sub {\n      text-align: center;\n      color: var(--text-muted);\n      font-size: 13px;\n      margin-bottom: 24px;\n    }\n\n    .login-tabs {\n      display: flex;\n      background: var(--page-bg);\n      border-radius: 999px;\n      padding: 4px;\n      margin-bottom: 22px;\n    }\n\n    .login-tabs button {\n      flex: 1;\n      padding: 10px 8px;\n      border-radius: 999px;\n      font-weight: 700;\n      font-size: 13.5px;\n      color: var(--text-mid);\n      transition: .15s;\n    }\n\n    .login-tabs button.active {\n      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));\n      color: #fff;\n      box-shadow: 0 3px 10px rgba(8, 145, 168, 0.3);\n    }\n\n    .form-field {\n      margin-bottom: 16px;\n    }\n\n    .form-field label {\n      display: block;\n      font-size: 13px;\n      font-weight: 600;\n      color: #0e2f4d;\n      margin-bottom: 6px;\n    }\n\n    .form-field label .req {\n      color: #e0433a;\n    }\n\n    .form-field input,\n    .form-field select {\n      width: 100%;\n      padding: 12px 14px;\n      border: 1.5px solid var(--border);\n      border-radius: var(--radius-sm);\n      font-size: 14px;\n      outline: none;\n      transition: .15s;\n      background: #fff;\n    }\n\n    .form-field input:focus,\n    .form-field select:focus {\n      border-color: var(--brand-teal);\n    }\n\n    .check-row {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-size: 13px;\n      color: var(--text-mid);\n      margin-bottom: 20px;\n    }\n\n    .btn-primary-full {\n      width: 100%;\n      padding: 13px;\n      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));\n      color: #fff;\n      font-weight: 700;\n      font-size: 15px;\n      border-radius: var(--radius-sm);\n      box-shadow: 0 4px 14px rgba(8, 145, 168, 0.28);\n      margin-bottom: 12px;\n    }\n\n    .btn-secondary-full {\n      width: 100%;\n      padding: 13px;\n      background: var(--page-bg);\n      color: var(--navy);\n      font-weight: 700;\n      font-size: 14.5px;\n      border-radius: var(--radius-sm);\n      border: 1.5px solid var(--border);\n    }\n\n    .login-terms {\n      text-align: center;\n      color: var(--text-muted);\n      font-size: 11.5px;\n      margin-top: 16px;\n    }\n\n    /* ============ APP SHELL ============ */\n    #app-shell {\n      display: none;\n      height: 100vh;\n      flex-direction: column;\n    }\n\n    #app-shell.active {\n      display: flex;\n    }\n\n    .app-body {\n      flex: 1;\n      display: flex;\n      position: relative;\n      overflow: hidden;\n      min-height: 0;\n    }\n\n    .sidebar {\n      width: var(--sidebar-w);\n      background: linear-gradient(180deg, #ffffff 0%, var(--water-foam) 100%);\n      border-right: 1px solid var(--border);\n      padding: 20px 16px;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      flex-shrink: 0;\n      position: relative;\n      z-index: 5;\n      box-shadow: 2px 0 16px rgba(74, 14, 30, 0.05);\n    }\n\n    .nav-btn {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding: 13px 16px;\n      border-radius: var(--radius-sm);\n      font-weight: 700;\n      font-size: 14px;\n      color: var(--navy);\n      border: 1.5px solid var(--border);\n      text-align: left;\n      transition: .15s;\n    }\n\n    .nav-btn i {\n      width: 16px;\n      text-align: center;\n    }\n\n    .nav-btn:hover {\n      border-color: var(--brand-green);\n    }\n\n    .nav-btn.active {\n      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));\n      color: #fff;\n      border-color: transparent;\n      box-shadow: 0 4px 14px rgba(8, 145, 168, 0.3);\n    }\n\n    .sidebar-spacer {\n      flex: 1;\n    }\n\n    .sidebar-map {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 6px;\n      padding: 16px 10px 18px;\n      margin: 8px 10px;\n      position: relative;\n      background: rgba(23, 52, 140, 0.04);\n      border-radius: 14px;\n      border: 1.5px solid rgba(23, 52, 140, 0.08);\n    }\n\n    .sidebar-map img {\n      width: 148px;\n      max-width: 90%;\n      mix-blend-mode: multiply;\n      opacity: .9;\n      display: block;\n    }\n\n    .sidebar-map .tag-line {\n      font-size: 10px;\n      color: var(--brand-teal);\n      font-weight: 700;\n      letter-spacing: 1.1px;\n      text-align: center;\n    }\n\n    .btn-feedback {\n      background: linear-gradient(100deg, var(--brand-green), var(--brand-teal));\n      color: #fff;\n      font-weight: 700;\n      padding: 13px 16px;\n      border-radius: var(--radius-sm);\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      justify-content: center;\n      box-shadow: 0 4px 14px rgba(21, 154, 92, 0.24);\n    }\n\n    .btn-logout {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      padding: 13px 16px;\n      border-radius: var(--radius-sm);\n      font-weight: 700;\n      font-size: 14px;\n      color: #9c2942;\n      background: #f7eef0;\n      border: 1.5px solid #9c2942;\n      transition: all 0.2s ease-in-out;\n      cursor: pointer;\n      box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n    }\n\n    .btn-logout:hover {\n      color: #ffffff;\n      background: #9c2942;\n      border-color: #9c2942;\n    }\n\n    .main-content {\n      flex: 1;\n      overflow-y: auto;\n      overflow-x: hidden;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      min-height: 0;\n    }\n\n    .main-content .watermark-wrap {\n      overflow: visible;\n      flex: none;\n      min-height: 100%;\n    }\n\n    .view {\n      display: none;\n      flex: 1;\n      flex-direction: column;\n      min-height: 0;\n    }\n\n    .view.active {\n      display: flex;\n      flex-direction: column;\n      min-height: 0;\n    }\n\n    /* ============ CHATBOT VIEW ============ */\n    .chat-topbar {\n      padding: 14px 30px;\n      border-bottom: 1px solid var(--border);\n      background: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      position: relative;\n      z-index: 3;\n    }\n\n    .chat-topbar p {\n      color: var(--text-mid);\n      font-size: 13.5px;\n    }\n\n    .lang-select {\n      border: 1.5px solid var(--border);\n      border-radius: var(--radius-sm);\n      padding: 6px 10px;\n      font-size: 13px;\n      color: var(--text-mid);\n      flex-shrink: 0;\n      margin-left: 16px;\n    }\n\n    .marquee-wrap {\n      flex: 1;\n      overflow: hidden;\n      white-space: nowrap;\n      position: relative;\n      mask-image: linear-gradient(90deg, transparent, #000 4%, #000 96%, transparent);\n      -webkit-mask-image: linear-gradient(90deg, transparent, #000 4%, #000 96%, transparent);\n    }\n\n    .marquee-text {\n      display: inline-block;\n      padding-left: 100%;\n      animation: marquee-scroll 22s linear infinite;\n      color: var(--text-mid);\n      font-size: 13.5px;\n    }\n\n    @keyframes marquee-scroll {\n      0% {\n        transform: translateX(0);\n      }\n\n      100% {\n        transform: translateX(-100%);\n      }\n    }\n\n    .sample-query-list {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      width: 100%;\n      max-width: 640px;\n    }\n\n    .chat-scroll {\n      flex: 1;\n      overflow-y: auto;\n      padding: 34px 40px;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      gap: 18px;\n    }\n\n    .chat-empty-state {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 22px;\n      text-align: center;\n      position: relative;\n      z-index: 2;\n    }\n\n    .mic-orb {\n      width: 110px;\n      height: 110px;\n      border-radius: 50%;\n      background: #fff;\n      border: 5px solid var(--orange-warn);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 34px;\n      color: var(--text-mid);\n      box-shadow: var(--shadow-md);\n    }\n\n    .chat-empty-state h3 {\n      font-size: 20px;\n      color: #0e2f4d;\n      font-weight: 800;\n    }\n\n    .sample-query {\n      background: #fff;\n      border-radius: var(--radius);\n      box-shadow: var(--shadow);\n      padding: 18px 22px;\n      max-width: 560px;\n      color: var(--text-mid);\n      font-size: 14px;\n      line-height: 1.6;\n      cursor: pointer;\n      border: 1.5px dashed var(--border);\n    }\n\n    .sample-query:hover {\n      border-color: var(--brand-teal);\n    }\n\n    .msg-row {\n      display: flex;\n      gap: 12px;\n      max-width: 78%;\n      position: relative;\n      z-index: 2;\n    }\n\n    .msg-row.bot {\n      align-self: flex-start;\n    }\n\n    .msg-row.user {\n      align-self: flex-end;\n      flex-direction: row-reverse;\n    }\n\n    .msg-avatar {\n      width: 34px;\n      height: 34px;\n      border-radius: 50%;\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 14px;\n      color: #fff;\n      font-weight: 700;\n    }\n\n    .msg-row.bot .msg-avatar {\n      background: linear-gradient(135deg, var(--orange-warn), var(--saffron));\n    }\n\n    .msg-row.user .msg-avatar {\n      background: var(--navy);\n    }\n\n    .msg-bubble {\n      background: #fff;\n      border-radius: 14px;\n      padding: 14px 18px;\n      box-shadow: var(--shadow);\n      font-size: 14px;\n      line-height: 1.65;\n      color: var(--text-dark);\n    }\n\n    .msg-row.user .msg-bubble {\n      background: #fff5e9;\n    }\n\n    .msg-bubble .msg-actions {\n      display: flex;\n      gap: 10px;\n      margin-top: 8px;\n      color: var(--text-muted);\n      font-size: 12px;\n    }\n\n    .msg-bubble .msg-actions i {\n      cursor: pointer;\n    }\n\n    .summary-card {\n      background: #fff;\n      border-radius: var(--radius-lg);\n      box-shadow: var(--shadow-md);\n      overflow: hidden;\n      max-width: 640px;\n      align-self: flex-start;\n      position: relative;\n      z-index: 2;\n    }\n\n    .summary-header {\n      background: linear-gradient(100deg, var(--brand-teal), var(--brand-green));\n      color: #fff;\n      padding: 14px 22px;\n      font-weight: 800;\n      font-size: 15px;\n    }\n\n    .summary-body {\n      padding: 20px 22px;\n    }\n\n    .summary-body>p {\n      color: var(--text-dark);\n      font-size: 13.8px;\n      line-height: 1.7;\n      margin-bottom: 16px;\n    }\n\n    .summary-table {\n      width: 100%;\n      border-collapse: collapse;\n      margin-bottom: 16px;\n    }\n\n    .summary-table td {\n      padding: 9px 4px;\n      border-bottom: 1px solid var(--border);\n      font-size: 13.5px;\n    }\n\n    .summary-table td:first-child {\n      color: var(--text-muted);\n      font-weight: 600;\n      width: 38%;\n    }\n\n    .summary-table td:last-child {\n      color: #0e2f4d;\n      font-weight: 600;\n    }\n\n    .dept-chip {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      background: var(--green-accent-2);\n      color: var(--brand-green-dark);\n      padding: 4px 12px;\n      border-radius: 999px;\n      font-weight: 700;\n      font-size: 13px;\n    }\n\n    .change-dept-btn {\n      color: var(--brand-teal);\n      font-weight: 700;\n      font-size: 13px;\n      border: 1.5px solid var(--brand-teal);\n      padding: 8px 14px;\n      border-radius: var(--radius-sm);\n      margin-bottom: 14px;\n    }\n\n    .dept-list {\n      display: none;\n      flex-direction: column;\n      gap: 8px;\n      margin-bottom: 16px;\n      background: var(--page-bg);\n      border-radius: var(--radius-sm);\n      padding: 12px;\n    }\n\n    .dept-list.show {\n      display: flex;\n    }\n\n    .dept-option {\n      padding: 10px 14px;\n      border-radius: var(--radius-sm);\n      border: 1.5px solid var(--border);\n      background: #fff;\n      font-size: 13.5px;\n      font-weight: 600;\n      color: var(--text-dark);\n      text-align: left;\n    }\n\n    .dept-option:hover {\n      border-color: var(--brand-teal);\n    }\n\n    .dept-option.selected {\n      border-color: var(--brand-green);\n      background: var(--green-accent-2);\n      color: var(--brand-green-dark);\n    }\n\n    .summary-body p.hint {\n      color: var(--text-mid);\n      font-size: 13px;\n      line-height: 1.6;\n      margin-bottom: 16px;\n    }\n\n    .summary-actions {\n      display: flex;\n      gap: 10px;\n    }\n\n    .btn-like,\n    .btn-dislike {\n      padding: 9px 16px;\n      border-radius: var(--radius-sm);\n      font-weight: 700;\n      font-size: 13px;\n      border: 1.5px solid var(--border);\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      color: var(--text-mid);\n    }\n\n    .btn-like.active {\n      background: var(--green-accent-2);\n      color: var(--brand-green-dark);\n      border-color: var(--brand-green);\n    }\n\n    .btn-dislike.active {\n      background: #fde3e1;\n      color: #c8382c;\n      border-color: #e0433a;\n    }\n\n    .btn-submit-grievance {\n      margin-left: auto;\n      padding: 9px 22px;\n      border-radius: var(--radius-sm);\n      font-weight: 700;\n      font-size: 13px;\n      background: var(--brand-green);\n      color: #fff;\n      box-shadow: 0 4px 12px rgba(21, 154, 92, 0.3);\n    }\n\n    .chat-input-bar {\n      padding: 16px 30px 22px;\n      background: transparent;\n      position: relative;\n      z-index: 3;\n    }\n\n    .chat-input-inner {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      background: #fff;\n      border-radius: 999px;\n      box-shadow: var(--shadow-md);\n      padding: 8px 8px 8px 18px;\n    }\n\n    .chat-input-inner input {\n      flex: 1;\n      border: none;\n      outline: none;\n      font-size: 14px;\n      background: transparent;\n    }\n\n    .icon-btn {\n      width: 38px;\n      height: 38px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--orange-warn);\n      font-size: 15px;\n      flex-shrink: 0;\n      transition: .15s;\n    }\n\n    .icon-btn.recording {\n      background: #fde3e1;\n      color: #e0433a;\n      animation: pulse 1s infinite;\n    }\n\n    @keyframes pulse {\n      0% {\n        box-shadow: 0 0 0 0 rgba(224, 67, 58, .4);\n      }\n\n      70% {\n        box-shadow: 0 0 0 9px rgba(224, 67, 58, 0);\n      }\n\n      100% {\n        box-shadow: 0 0 0 0 rgba(224, 67, 58, 0);\n      }\n    }\n\n    .send-btn {\n      width: 42px;\n      height: 42px;\n      border-radius: 50%;\n      background: var(--brand-green);\n      color: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 15px;\n      flex-shrink: 0;\n      box-shadow: 0 4px 12px rgba(21, 154, 92, 0.3);\n    }\n\n    .typing-indicator {\n      display: flex;\n      gap: 4px;\n      align-items: center;\n      padding: 14px 18px;\n    }\n\n    .typing-indicator span {\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background: var(--text-muted);\n      animation: blink 1.2s infinite ease-in-out;\n    }\n\n    .typing-indicator span:nth-child(2) {\n      animation-delay: .2s;\n    }\n\n    .typing-indicator span:nth-child(3) {\n      animation-delay: .4s;\n    }\n\n    @keyframes blink {\n\n      0%,\n      80%,\n      100% {\n        opacity: .25;\n      }\n\n      40% {\n        opacity: 1;\n      }\n    }\n\n    @keyframes orbPulse {\n\n      0%,\n      100% {\n        box-shadow: 0 0 0 8px rgba(14, 158, 143, 0.2);\n      }\n\n      50% {\n        box-shadow: 0 0 0 18px rgba(14, 158, 143, 0.05);\n      }\n    }\n\n    /* ============ DASHBOARD (USER) ============ */\n    .view-inner {\n      padding: 28px 36px 40px;\n      flex: 1;\n      position: relative;\n      z-index: 2;\n    }\n\n    .view-inner h2.page-title {\n      font-size: 20px;\n      color: #0e2f4d;\n      margin-bottom: 20px;\n      font-weight: 800;\n    }\n\n    .stat-cards {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 20px;\n      margin-bottom: 24px;\n    }\n\n    .stat-card {\n      border-radius: var(--radius-lg);\n      padding: 22px 24px;\n      color: #fff;\n      position: relative;\n      overflow: hidden;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      box-shadow: var(--shadow-md);\n    }\n\n    .stat-card.c1 {\n      background: linear-gradient(135deg, #8B1A4A, #5C0F28);\n    }\n\n    .stat-card.c2 {\n      background: linear-gradient(135deg, #D4A017, #A57A0E);\n    }\n\n    .stat-card.c3 {\n      background: linear-gradient(135deg, #B5366B, #8B1A4A);\n    }\n\n    .stat-card .top-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n    }\n\n    .stat-card .top-row span {\n      font-weight: 700;\n      font-size: 13.5px;\n      max-width: 75%;\n      line-height: 1.4;\n    }\n\n    .stat-card .icon-circle {\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n      background: rgba(255, 255, 255, 0.22);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 15px;\n    }\n\n    .stat-card .stat-num {\n      font-size: 34px;\n      font-weight: 900;\n    }\n\n    .card {\n      background: #fff;\n      border-radius: var(--radius-lg);\n      box-shadow: var(--shadow);\n      padding: 22px;\n      border: 1px solid var(--border);\n      position: relative;\n      overflow: hidden;\n    }\n\n    /* Subtle lotus watermark on cards */\n    .card::before {\n      content: \"✿\";\n      position: absolute;\n      bottom: -12px;\n      right: -8px;\n      font-size: 72px;\n      color: rgba(181, 54, 107, 0.04);\n      pointer-events: none;\n      z-index: 0;\n    }\n\n    .card h3 {\n      font-size: 15.5px;\n      margin-bottom: 16px;\n      color: var(--navy);\n      font-family: 'Playfair Display', serif;\n      position: relative;\n      z-index: 1;\n    }\n\n    .grid-2 {\n      display: grid;\n      grid-template-columns: 1.1fr 1.4fr;\n      gap: 20px;\n      margin-bottom: 24px;\n    }\n\n    .grid-2b {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 20px;\n      margin-bottom: 24px;\n    }\n\n    .search-bar {\n      width: 100%;\n      max-width: 320px;\n      padding: 11px 14px;\n      border: 1.5px solid var(--border);\n      border-radius: var(--radius-sm);\n      margin-bottom: 18px;\n      font-size: 13.5px;\n    }\n\n    table.data-table {\n      width: 100%;\n      border-collapse: collapse;\n    }\n\n    table.data-table th {\n      position: sticky;\n      top: 0;\n      background: linear-gradient(90deg, #FDF0F4 0%, #FAE8F0 100%);\n      z-index: 5;\n      text-align: left;\n      font-size: 12px;\n      color: var(--navy);\n      padding: 10px 12px;\n      border-bottom: 2px solid var(--petal-pink);\n      text-transform: uppercase;\n      letter-spacing: .6px;\n      font-weight: 700;\n    }\n\n    table.data-table td {\n      padding: 13px 12px;\n      border-bottom: 1px solid var(--border);\n      font-size: 13.5px;\n      color: var(--text-dark);\n    }\n\n    table.data-table td.grid-id {\n      color: var(--brand-teal);\n      font-weight: 700;\n    }\n\n    .status-badge {\n      padding: 5px 14px;\n      border-radius: 999px;\n      font-weight: 700;\n      font-size: 12px;\n      color: #fff;\n      display: inline-block;\n    }\n\n    .status-badge.open {\n      background: linear-gradient(135deg, #D98A20, #B5700D);\n    }\n\n    .status-badge.closed,\n    .status-badge.resolved {\n      background: linear-gradient(135deg, #2D9A6B, #1F7050);\n    }\n\n    .status-badge.in-progress {\n      background: linear-gradient(135deg, #4A6FC8, #2D4FA0);\n    }\n\n    .status-filter {\n      border: 1.5px solid var(--border);\n      border-radius: var(--radius-sm);\n      padding: 6px 10px;\n      font-size: 12.5px;\n    }\n\n    .view-eye {\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      background: var(--green-accent-2);\n      color: var(--brand-green-dark);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    /* ============ SORTABLE TABLE HEADERS (officer view) ============ */\n    table.data-table th.sortable {\n      cursor: pointer;\n      user-select: none;\n      white-space: nowrap;\n    }\n\n    table.data-table th.sortable i {\n      margin-left: 5px;\n      font-size: 10px;\n      color: var(--text-muted);\n    }\n\n    table.data-table th.sortable.sort-active i {\n      color: var(--brand-teal);\n    }\n\n    .officer-toolbar {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 16px;\n      flex-wrap: wrap;\n      margin-bottom: 16px;\n    }\n\n    .officer-toolbar .search-bar {\n      margin-bottom: 0;\n    }\n\n    /* Officer mid-grid: pie chart + overdue side by side */\n    .officer-mid-grid {\n      display: grid;\n      grid-template-columns: 260px 1fr;\n      gap: 20px;\n      margin-top: 20px;\n    }\n\n    .officer-chart-card {\n      min-height: 240px;\n    }\n\n    .officer-overdue-card {\n      overflow: hidden;\n    }\n\n    /* Add Comment button — amber/gold like the screenshot */\n    .officer-add-comment-btn {\n      background: #e8a53d;\n      color: #fff;\n      font-size: 11.5px;\n      font-weight: 700;\n      padding: 5px 12px;\n      border-radius: 6px;\n      border: none;\n      cursor: pointer;\n      white-space: nowrap;\n      transition: background .15s;\n    }\n\n    .officer-add-comment-btn:hover {\n      background: #d4912a;\n    }\n\n    /* Comment pill — shown when comment has been saved */\n    .officer-comment-pill {\n      display: inline-block;\n      background: #f0faf5;\n      color: #0e7a48;\n      font-size: 11px;\n      font-weight: 600;\n      padding: 4px 10px;\n      border-radius: 6px;\n      border: 1.5px solid rgba(21, 154, 92, 0.3);\n      max-width: 160px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      cursor: default;\n    }\n\n    /* Resolved status badge */\n    .status-badge.resolved {\n      background: rgba(21, 154, 92, 0.12);\n      color: #0e7a48;\n    }\n\n    /* ============ ROTATING SUGGESTED QUESTION ============ */\n    .suggest-box {\n      background: #fff;\n      border-radius: var(--radius);\n      box-shadow: var(--shadow);\n      padding: 18px 22px;\n      max-width: 560px;\n      color: var(--text-mid);\n      font-size: 14px;\n      line-height: 1.6;\n      cursor: pointer;\n      border: 1.5px dashed var(--border);\n      position: relative;\n      min-height: 56px;\n      display: flex;\n      align-items: center;\n    }\n\n    .suggest-box:hover {\n      border-color: var(--brand-teal);\n    }\n\n    .suggest-box .suggest-label {\n      position: absolute;\n      top: -11px;\n      left: 16px;\n      background: var(--brand-teal);\n      color: #fff;\n      font-size: 10.5px;\n      font-weight: 700;\n      letter-spacing: .4px;\n      padding: 3px 10px;\n      border-radius: 999px;\n      text-transform: uppercase;\n    }\n\n    .suggest-box .suggest-text {\n      transition: opacity .25s ease;\n    }\n\n    .suggest-box .suggest-text.fade {\n      opacity: 0;\n    }\n\n    /* ============ MODALS ============ */\n    .modal-overlay {\n      display: none;\n      position: fixed;\n      inset: 0;\n      background: rgba(15, 25, 45, 0.5);\n      z-index: 100;\n      align-items: center;\n      justify-content: center;\n      padding: 20px;\n    }\n\n    .modal-overlay.show {\n      display: flex;\n    }\n\n    .modal-box {\n      background: #fff;\n      border-radius: var(--radius-lg);\n      box-shadow: var(--shadow-md);\n      max-width: 520px;\n      width: 100%;\n      max-height: 88vh;\n      overflow-y: auto;\n      position: relative;\n    }\n\n    .modal-box.wide {\n      max-width: 760px;\n    }\n\n    .modal-close {\n      position: absolute;\n      top: 16px;\n      right: 16px;\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      background: var(--page-bg);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--text-mid);\n      font-size: 14px;\n      z-index: 2;\n    }\n\n    .modal-close:hover {\n      background: #f0d9d8;\n      color: #c8382c;\n    }\n\n    .success-modal-body {\n      padding: 46px 40px 38px;\n      text-align: center;\n    }\n\n    .success-check {\n      width: 80px;\n      height: 80px;\n      border-radius: 50%;\n      background: var(--green-accent-2);\n      color: var(--brand-green);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 36px;\n      margin: 0 auto 20px;\n    }\n\n    .success-modal-body h3 {\n      font-size: 20px;\n      color: #0e2f4d;\n      margin-bottom: 10px;\n    }\n\n    .success-modal-body p {\n      color: var(--text-mid);\n      font-size: 14px;\n      margin-bottom: 4px;\n    }\n\n    .success-modal-body .grievance-id-box {\n      display: inline-block;\n      margin: 14px 0 26px;\n      background: var(--page-bg);\n      border: 1.5px dashed var(--brand-green);\n      border-radius: var(--radius-sm);\n      padding: 10px 22px;\n      font-weight: 800;\n      color: var(--brand-green-dark);\n      font-size: 16px;\n    }\n\n    .success-modal-body .btn-row {\n      display: flex;\n      gap: 12px;\n    }\n\n    .success-modal-body .btn-row button {\n      flex: 1;\n      padding: 13px;\n      border-radius: var(--radius-sm);\n      font-weight: 700;\n      font-size: 14px;\n    }\n\n    .btn-ok {\n      background: var(--page-bg);\n      color: var(--navy);\n      border: 1.5px solid var(--border);\n    }\n\n    .btn-dash {\n      background: var(--brand-green);\n      color: #fff;\n      box-shadow: 0 4px 14px rgba(21, 154, 92, 0.3);\n    }\n\n    .view-query-header {\n      padding: 22px 26px;\n      border-bottom: 1px solid var(--border);\n    }\n\n    .view-query-header h3 {\n      font-size: 18px;\n      color: #0e2f4d;\n    }\n\n    .view-query-body {\n      padding: 22px 26px;\n    }\n\n    .vq-label {\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: .5px;\n      color: var(--text-muted);\n      font-weight: 700;\n      margin-bottom: 6px;\n      margin-top: 18px;\n    }\n\n    .vq-label:first-child {\n      margin-top: 0;\n    }\n\n    .vq-text {\n      font-size: 14px;\n      color: var(--text-dark);\n      line-height: 1.65;\n    }\n\n    .vq-comment-box {\n      background: var(--page-bg);\n      border-radius: var(--radius-sm);\n      padding: 14px;\n      color: var(--text-muted);\n      font-size: 13.5px;\n      font-style: italic;\n    }\n\n    .vq-grid {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n      margin-top: 18px;\n    }\n\n    .vq-field label {\n      display: block;\n      font-size: 11.5px;\n      text-transform: uppercase;\n      color: var(--text-muted);\n      font-weight: 700;\n      margin-bottom: 5px;\n    }\n\n    .vq-field .val {\n      font-size: 13.8px;\n      font-weight: 600;\n      color: #0e2f4d;\n    }\n\n    /* ============ AI COMPLAINT SUMMARY ============ */\n    .ai-section-title {\n      font-size: 12px;\n      font-weight: 800;\n      letter-spacing: .06em;\n      text-transform: uppercase;\n      color: var(--text-muted);\n      margin: 22px 0 8px;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .ai-section-title:first-child {\n      margin-top: 0;\n    }\n\n    .ai-section-title i {\n      color: var(--brand-teal);\n    }\n\n    .ai-badge {\n      display: inline-flex;\n      align-items: center;\n      gap: 5px;\n      background: var(--green-accent-2);\n      color: var(--brand-teal);\n      border: 1px solid var(--brand-teal);\n      font-size: 10.5px;\n      font-weight: 800;\n      text-transform: uppercase;\n      letter-spacing: .04em;\n      padding: 3px 9px;\n      border-radius: 999px;\n      margin-left: 8px;\n    }\n\n    .ai-summary-card {\n      background: var(--page-bg);\n      border-left: 4px solid var(--brand-teal);\n      border-radius: var(--radius-sm);\n      padding: 14px 16px;\n      font-size: 13.5px;\n      line-height: 1.7;\n      color: var(--text-dark);\n    }\n\n    .raw-input-toggle {\n      cursor: pointer;\n      color: var(--brand-teal);\n      font-weight: 700;\n      font-size: 13px;\n      margin: 14px 0 6px;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      user-select: none;\n    }\n\n    .raw-input-toggle i {\n      transition: transform .2s ease;\n      font-size: 11px;\n    }\n\n    .raw-input-toggle.open i {\n      transform: rotate(180deg);\n    }\n\n    .raw-input-box {\n      background: var(--blush-bg, #f7eef0);\n      border: 1px solid var(--border);\n      border-radius: var(--radius-sm);\n      padding: 12px 14px;\n      font-size: 13px;\n      color: var(--text-mid);\n      display: none;\n      line-height: 1.6;\n    }\n\n    .raw-input-box.open {\n      display: block;\n    }\n\n    .slot-grid {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 12px;\n      margin-top: 10px;\n    }\n\n    .slot-field {\n      background: var(--surface);\n      border: 1px solid var(--border);\n      border-left: 3px solid var(--gold);\n      border-radius: var(--radius-sm);\n      padding: 10px 12px;\n    }\n\n    .slot-field label {\n      display: block;\n      font-size: 11px;\n      text-transform: uppercase;\n      letter-spacing: .04em;\n      color: var(--text-muted);\n      font-weight: 700;\n      margin-bottom: 4px;\n    }\n\n    .slot-field .val {\n      font-weight: 700;\n      color: var(--text-dark);\n      font-size: 13.8px;\n    }\n\n    /* ============ BTR (BRIEF TRANSMISSION REPORT) ============ */\n    .btr-panel {\n      background: var(--surface);\n      border: 1.5px solid var(--border);\n      border-radius: var(--radius);\n      padding: 16px 18px;\n      margin-top: 6px;\n    }\n\n    .btr-panel textarea {\n      width: 100%;\n      min-height: 80px;\n      border: 1.5px solid var(--border);\n      border-radius: var(--radius-sm);\n      padding: 10px 12px;\n      font-size: 13.3px;\n      font-family: inherit;\n      line-height: 1.6;\n      resize: vertical;\n      color: var(--text-dark);\n      background: var(--page-bg);\n    }\n\n    .btr-panel textarea:disabled {\n      background: #f1eaeb;\n      color: var(--text-mid);\n      cursor: not-allowed;\n    }\n\n    .btr-field-label {\n      font-size: 12px;\n      font-weight: 800;\n      color: var(--text-mid);\n      margin: 14px 0 6px;\n      text-transform: uppercase;\n      letter-spacing: .03em;\n    }\n\n    .btr-field-label:first-child {\n      margin-top: 0;\n    }\n\n    .btr-chrono-list {\n      list-style: none;\n      padding: 0;\n      margin: 4px 0 0;\n    }\n\n    .btr-chrono-list li {\n      position: relative;\n      padding: 6px 0 6px 20px;\n      font-size: 13.2px;\n      color: var(--text-dark);\n      border-left: 2px solid var(--brand-teal);\n      margin-left: 4px;\n    }\n\n    .btr-chrono-list li::before {\n      content: \"\";\n      position: absolute;\n      left: -5px;\n      top: 12px;\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n      background: var(--brand-teal);\n    }\n\n    .btr-status-pill {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 11.5px;\n      font-weight: 800;\n      text-transform: uppercase;\n      letter-spacing: .04em;\n      padding: 4px 12px;\n      border-radius: 999px;\n    }\n\n    .btr-status-pill.draft {\n      background: #f3e4c0;\n      color: #8a5f10;\n    }\n\n    .btr-status-pill.submitted {\n      background: var(--green-accent-2);\n      color: var(--brand-teal);\n    }\n\n    .btr-status-pill.approved {\n      background: #d9f2e6;\n      color: var(--brand-green-dark);\n    }\n\n    .btr-status-pill.returned {\n      background: #fbdede;\n      color: #a12626;\n    }\n\n    .btr-actions {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n      margin-top: 16px;\n    }\n\n    .btr-btn {\n      border: none;\n      border-radius: 8px;\n      padding: 9px 18px;\n      font-size: 13px;\n      font-weight: 700;\n      cursor: pointer;\n    }\n\n    .btr-btn.ai {\n      background: var(--surface);\n      border: 1.5px solid var(--brand-teal);\n      color: var(--brand-teal);\n    }\n\n    .btr-btn.save {\n      background: var(--page-bg);\n      border: 1.5px solid var(--border);\n      color: var(--text-dark);\n    }\n\n    .btr-btn.submit {\n      background: var(--brand-teal);\n      color: #fff;\n    }\n\n    .btr-btn.approve {\n      background: var(--brand-green);\n      color: #fff;\n    }\n\n    .btr-btn.return {\n      background: #fff;\n      border: 1.5px solid #c1671f;\n      color: #c1671f;\n    }\n\n    .btr-btn:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n\n    .vq-footer {\n      padding: 18px 26px;\n      border-top: 1px solid var(--border);\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    .btn-close-modal {\n      background: var(--page-bg);\n      color: var(--navy);\n      font-weight: 700;\n      padding: 10px 26px;\n      border-radius: var(--radius-sm);\n      border: 1.5px solid var(--border);\n    }\n\n    .feedback-body {\n      padding: 34px 32px 30px;\n      text-align: center;\n    }\n\n    .feedback-body h3 {\n      font-size: 18px;\n      color: #0e2f4d;\n      margin-bottom: 24px;\n    }\n\n    .star-row {\n      display: flex;\n      justify-content: center;\n      gap: 14px;\n      margin-bottom: 8px;\n    }\n\n    .star-item {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 6px;\n      cursor: pointer;\n    }\n\n    .star-item i {\n      font-size: 26px;\n      color: #dbe0e6;\n      transition: .15s;\n    }\n\n    .star-item span {\n      font-size: 11px;\n      color: var(--text-muted);\n      font-weight: 600;\n    }\n\n    .star-item.active i,\n    .star-item.filled i {\n      color: #f0a63c;\n    }\n\n    .feedback-body textarea {\n      width: 100%;\n      min-height: 100px;\n      border: 1.5px solid var(--border);\n      border-radius: var(--radius-sm);\n      padding: 14px;\n      font-size: 13.5px;\n      margin: 22px 0 20px;\n      outline: none;\n      resize: vertical;\n    }\n\n    .feedback-body textarea:focus {\n      border-color: var(--brand-teal);\n    }\n\n    .btn-submit-fb {\n      width: 100%;\n      padding: 13px;\n      background: var(--brand-green);\n      color: #fff;\n      font-weight: 700;\n      border-radius: var(--radius-sm);\n      box-shadow: 0 4px 14px rgba(21, 154, 92, 0.28);\n    }\n\n    /* ============ REGISTER OFFICER ============ */\n    .register-card {\n      background: #fff;\n      border-radius: var(--radius-lg);\n      box-shadow: var(--shadow);\n      max-width: 900px;\n      margin: 34px auto;\n      padding: 40px 46px;\n      position: relative;\n      z-index: 2;\n    }\n\n    .register-card h2 {\n      text-align: center;\n      color: var(--brand-green-dark);\n      font-size: 22px;\n      margin-bottom: 6px;\n    }\n\n    .register-card p.sub {\n      text-align: center;\n      color: var(--text-muted);\n      font-size: 13.5px;\n      margin-bottom: 30px;\n    }\n\n    .form-grid-2 {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 20px 26px;\n      margin-bottom: 26px;\n    }\n\n    .register-btn-row {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 20px;\n    }\n\n    .btn-back {\n      background: #7c8695;\n      color: #fff;\n      font-weight: 700;\n      padding: 13px;\n      border-radius: var(--radius-sm);\n    }\n\n    .btn-register {\n      background: linear-gradient(100deg, var(--brand-teal), var(--brand-green));\n      color: #fff;\n      font-weight: 700;\n      padding: 13px;\n      border-radius: var(--radius-sm);\n      box-shadow: 0 4px 14px rgba(21, 154, 92, 0.3);\n    }\n\n    .officer-list-card {\n      max-width: 900px;\n      margin: 0 auto 34px;\n      position: relative;\n      z-index: 2;\n    }\n\n    /* ============ EMPTY STATE (Officer) ============ */\n    .empty-state {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 16px;\n      text-align: center;\n      position: relative;\n      z-index: 2;\n      padding: 40px;\n    }\n\n    .empty-state .icon {\n      width: 88px;\n      height: 88px;\n      border-radius: 50%;\n      background: var(--green-accent-2);\n      color: var(--brand-green);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 34px;\n    }\n\n    .empty-state h3 {\n      font-size: 19px;\n      color: #0e2f4d;\n    }\n\n    .empty-state p {\n      color: var(--text-mid);\n      font-size: 13.8px;\n      max-width: 400px;\n      line-height: 1.6;\n    }\n\n    /* ============ TOAST ============ */\n    .toast {\n      position: fixed;\n      bottom: 26px;\n      left: 50%;\n      transform: translateX(-50%) translateY(20px);\n      background: #0e2f4d;\n      color: #fff;\n      padding: 13px 26px;\n      border-radius: 999px;\n      font-size: 13.5px;\n      font-weight: 600;\n      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n      z-index: 200;\n      opacity: 0;\n      pointer-events: none;\n      transition: .25s;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n\n    .toast.show {\n      opacity: 1;\n      transform: translateX(-50%) translateY(0);\n    }\n\n    .toast i {\n      color: #3ecf8e;\n    }\n\n    /* misc */\n    .chart-scroll-wrap {\n      overflow-x: auto;\n    }\n\n    ::-webkit-scrollbar {\n      width: 7px;\n      height: 7px;\n    }\n\n    ::-webkit-scrollbar-track {\n      background: var(--rose-light);\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: linear-gradient(180deg, var(--water-teal), var(--water-mid));\n      border-radius: 4px;\n    }\n\n    /* ===== Women-Empowerment Empowerment Tag decorations ===== */\n    .empowerment-tag {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      background: linear-gradient(90deg, var(--water-deep), var(--water-teal));\n      color: #fff;\n      font-size: 10px;\n      font-weight: 800;\n      letter-spacing: 1.2px;\n      text-transform: uppercase;\n      padding: 4px 12px;\n      border-radius: 999px;\n    }\n\n    /* Lotus animation for empty states */\n    @keyframes lotusBloom {\n      0% { transform: scale(0.95) rotate(-3deg); opacity: 0.7; }\n      50% { transform: scale(1.05) rotate(3deg); opacity: 1; }\n      100% { transform: scale(0.95) rotate(-3deg); opacity: 0.7; }\n    }\n\n    .empty-state .icon {\n      animation: lotusBloom 3s ease-in-out infinite;\n      background: linear-gradient(135deg, var(--blush-bg), var(--water-foam));\n      color: var(--brand-teal);\n    }\n\n    /* Page titles — Playfair Display for elegance */\n    .view-inner h2.page-title,\n    .register-card h2,\n    .live-updates-card h4 {\n      font-family: 'Playfair Display', Georgia, serif;\n      color: var(--navy);\n    }\n\n    /* Login card top border — rose gradient */\n    .login-card {\n      border-top: 4px solid transparent;\n      background-clip: padding-box;\n      position: relative;\n    }\n    .login-card::before {\n      content: '';\n      position: absolute;\n      top: 0; left: 0; right: 0;\n      height: 4px;\n      background: linear-gradient(90deg, var(--water-deep), var(--water-teal), var(--gold));\n      border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n      z-index: 1;\n    }\n\n    /* SweetAlert2 button — rose gradient */\n    .swal2-confirm.swal2-styled {\n      background-image: linear-gradient(to right, var(--water-teal), var(--water-mid)) !important;\n      background-color: transparent !important;\n      border: none !important;\n    }\n\n    /* BTR panel accent — rose border */\n    .btr-chrono-list li {\n      border-left: 2px solid var(--water-teal);\n    }\n    .btr-chrono-list li::before {\n      background: var(--water-teal);\n    }\n\n    /* Ripple dots — rose tones */\n    .ripple-dot {\n      border: 1px solid rgba(181, 54, 107, 0.18);\n    }\n\n    /* Nav active button — rose gradient */\n    .nav-btn.active {\n      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));\n      color: #fff;\n      border-color: transparent;\n      box-shadow: 0 4px 14px rgba(139, 26, 74, 0.32);\n    }\n\n    /* Register button — rose gradient */\n    .btn-register {\n      background: linear-gradient(100deg, var(--water-teal), var(--water-mid));\n      color: #fff;\n      font-weight: 700;\n      padding: 13px;\n      border-radius: var(--radius-sm);\n      box-shadow: 0 4px 14px rgba(139, 26, 74, 0.30);\n    }\n\n    /* Send button — rose */\n    .send-btn {\n      background: linear-gradient(135deg, var(--water-teal), var(--water-mid));\n      box-shadow: 0 4px 14px rgba(139, 26, 74, 0.32);\n    }\n\n    /* Sample query hover */\n    .sample-query:hover,\n    .suggest-box:hover {\n      border-color: var(--water-teal);\n      background: #FDF0F4;\n    }\n\n    /* Suggest label pill */\n    .suggest-box .suggest-label {\n      background: var(--water-teal);\n    }\n\n    /* AI summary border */\n    .ai-summary-card {\n      border-left: 4px solid var(--water-teal);\n      background: var(--blush-bg);\n    }\n\n    /* BTR btn — rose accents */\n    .btr-btn.submit, .btr-btn.ai {\n      border-color: var(--water-teal);\n      color: var(--water-teal);\n    }\n    .btr-btn.submit {\n      background: var(--water-teal);\n      color: #fff;\n    }\n\n    /* Feedback submit button */\n    .btn-submit-fb, .btn-dash {\n      background: linear-gradient(135deg, var(--water-teal), var(--water-mid));\n      box-shadow: 0 4px 14px rgba(139, 26, 74, 0.28);\n    }\n\n    /* Table row hover — soft rose tint */\n    table.data-table tbody tr:hover {\n      background: #FDF0F4;\n      transition: background 0.15s ease;\n    }\n\n    /* Table alternate rows */\n    table.data-table tbody tr:nth-child(even) {\n      background: #FEFBFC;\n    }\n\n    /* Tooltip / popover — rose background */\n    .btr-status-pill.submitted {\n      background: var(--blush-bg);\n      color: var(--water-teal);\n      border: 1px solid var(--water-teal);\n    }\n\n    /* Primary full button */\n    .btn-primary-full {\n      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));\n    }\n\n    /* Login tab active */\n    .login-tabs button.active {\n      background: linear-gradient(100deg, var(--water-deep), var(--water-teal));\n      box-shadow: 0 3px 10px rgba(139, 26, 74, 0.3);\n    }\n\n    /* Profile avatar */\n    .profile-avatar {\n      background: linear-gradient(135deg, var(--water-teal), var(--water-mid));\n    }\n\n    /* Floating lotus decoration for dashboard */\n    @keyframes floatLotus {\n      0%, 100% { transform: translateY(0px) rotate(0deg); }\n      33% { transform: translateY(-8px) rotate(3deg); }\n      66% { transform: translateY(-4px) rotate(-2deg); }\n    }\n    .lotus-float {\n      animation: floatLotus 6s ease-in-out infinite;\n      display: inline-block;\n    }\n\n    /* Mic orb — rose */\n    .mic-orb {\n      border-color: var(--water-teal);\n    }\n\n    /* Success check — rose */\n    .success-check {\n      background: var(--blush-bg);\n      color: var(--water-teal);\n    }\n\n    /* User message bubble — soft rose */\n    .msg-row.user .msg-bubble {\n      background: linear-gradient(135deg, #FCE8EF, #FDF0F4);\n    }\n\n    /* Dept chip */\n    .dept-chip {\n      background: var(--blush-bg);\n      color: var(--water-mid);\n    }\n\n    /* Logout button — rose */\n    .btn-logout {\n      color: var(--water-teal);\n      background: #FCE8EF;\n      border: 1.5px solid var(--water-teal);\n    }\n    .btn-logout:hover {\n      color: #fff;\n      background: var(--water-teal);\n      border-color: var(--water-teal);\n    }\n\n    /* Sidebar */\n    .sidebar {\n      background: linear-gradient(180deg, #ffffff 0%, #FDF0F4 100%);\n      border-right: 1px solid var(--border);\n    }\n\n    /* nav-btn hover — rose */\n    .nav-btn:hover {\n      border-color: var(--water-teal);\n      background: #FCE8EF;\n    }\n\n    /* Form field focus — rose */\n    .form-field input:focus,\n    .form-field select:focus {\n      border-color: var(--water-teal);\n      box-shadow: 0 0 0 3px rgba(181, 54, 107, 0.10);\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
